<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-joylearning__registeuserlist}">
      <label class="divMessage"
        >课程名称：{{
          courseName
        }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;开始和结束时间：{{
          courseStartDate
        }}
        - {{ courseEndDate }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;所在场地：{{
          siteName
        }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;排期价格(元)：{{
          formatMoney(dataForm.coursePrice)
        }}</label
      >
      <hr />
      <!-- 顶部table -->
      <el-form :model="dataForm" @keyup.enter.native="getDataList()">
        <el-row class="margb10">
          <!-- 姓名 :inline="true"-->
          <el-col :span="7">
            <el-form-item :label="$t('registe.username')" label-width="90px">
              <el-input
                v-model="dataForm.userName"
                :placeholder="$t('请输入')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 时间（起始） -->
          <el-col :span="14">
            <el-form-item :label="$t('assign.updateTimeRange')" label-width="180px">
              <!-- <span slot="label">{{$t('assign.timeRange')}}</span> -->
              <el-date-picker
                style="width: 100%"
                v-model="dateRange"
                type="daterange"
                format="yyyy-MM-dd"
                range-separator="-"
                :start-placeholder="$t('registe.startdate')"
                :end-placeholder="$t('registe.enddate')"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 查询 -->
          <el-col :span="3">
            <el-col :span="24">
              <el-button class="M-search" type="primary" @click="getDataListMerge">{{
                $t("query")
              }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <!-- ---->
        <el-row class="margb10">
          <!-- 选择经销商 -->
          <el-col :span="7">
            <el-form-item :label="$t('registe.company')" label-width="90px">
              <el-input v-model="dataForm.orgName" :placeholder="$t('请输入')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14"> &nbsp; </el-col>
          <!-- 重置 -->
          <el-col :span="3">
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l" type="info" @click="again">{{
                $t("reset")
              }}</el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <br />
      <!-- 添加用户 -->
      <div class="search">
        <el-button type="primary" @click="adduser()" v-show="this.offeringStatus !== '30'"
          >{{ $t("registe.adduser") }}
        </el-button>
        <el-button type="primary" @click="exportHandle()">{{ $t("export") }} </el-button>
        <el-button
          type="primary"
          v-if="$hasPermission('learning:offering:exportSignListToItm')"
          @click="exportSignListToItm()"
          >{{ $t("ITM格式导出") }}
        </el-button>
        <el-button type="primary" @click="showWaitingList()"
          >{{ $t("registe.queryWaitingList") }}
        </el-button>
        <div style="float: right">
          <!-- 显示已撤销用户 -->
          <el-checkbox style="margin-top: 12px" v-model="isNo" @change="isCheck()">{{
            $t("registe.displayRevokedList")
          }}</el-checkbox>
          <!-- 查看等待名单 v-if="false"-->
          <!-- <el-dropdown-item style="float:right; color: #1c69d3;"
                            @click.native="showWaitingList">{{ $t('registe.queryWaitingList') }}</el-dropdown-item> -->
        </div>
      </div>
      <!-- 表头动态展示(还得改)
      // 审批状态 approvalStatus 10 待审核 20 已同意 30 已拒绝 40 已撤销
      -->
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
      >
        <!-- 用户ID -->
        <el-table-column
          prop="userCode"
          header-align="center"
          show-overflow-tooltip
          align="center"
          :label="$t('offering.resource.trainerId')"
        >
        </el-table-column>
        <!-- 员工号 -->
        <el-table-column
          prop="userCardNo"
          header-align="center"
          show-overflow-tooltip
          align="center"
          :label="$t('trainer.userCardNo')"
        >
        </el-table-column>
        <!-- 姓名 -->
        <el-table-column
          prop="userName"
          :show-overflow-tooltip="true"
          :label="$t('registe.username')"
          width="80"
          align="center"
        >
          <!-- <template slot-scope="scope"> {{scope.row.firstNameCn}}{{scope.row.lastNameCn}} </template> -->
        </el-table-column>
        <!-- 身份证号 -->
        <el-table-column
          prop="idcard"
          :label="$t('assign.idNumber')"
          show-overflow-tooltip
          width="150"
          align="center"
        >
        </el-table-column>
        <!-- 经销商 -->
        <el-table-column
          prop="orgName"
          :label="$t('registe.company')"
          show-overflow-tooltip
          width="150"
          align="center"
        >
        </el-table-column>
        <!-- bba编码 -->
        <el-table-column
          prop="bbaNo"
          width="150"
          align="center"
          :label="$t('assign.bbaNo')"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- nsc编码 -->
        <el-table-column
          prop="nscNo"
          width="150"
          align="center"
          :label="$t('assign.nscNo')"
          show-overflow-tooltip
        >
        </el-table-column>
        <!-- 主要职位 -->
        <el-table-column
          prop="positionNameCn"
          :label="$t('assign.positionname')"
          width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- 兼职职位1 -->
        <el-table-column
          prop="partTimeJobOne"
          :label="$t('assign.parttimejobone')"
          width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- 兼职职位2 -->
        <el-table-column
          prop="partTimeJobTwo"
          :label="$t('assign.parttimejobtwo')"
          width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- 兼职职位3 -->
        <el-table-column
                prop="partTimeJobThree"
                :label="$t('assign.partTimeJobThree')"
                width="120"
                show-overflow-tooltip
                align="center"
        >
        </el-table-column>
        <!-- 兼职职位4 -->
        <el-table-column
                prop="partTimeJobFour"
                :label="$t('assign.partTimeJobFour')"
                width="120"
                show-overflow-tooltip
                align="center"
        >
        </el-table-column>
        <!-- 兼职职位5 -->
        <el-table-column
                prop="partTimeJobFive"
                :label="$t('assign.partTimeJobFive')"
                width="120"
                show-overflow-tooltip
                align="center"
        >
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          prop="approvalStatus"
          :formatter="registeapprovalstatus"
          :label="$t('assign.status')"
          show-overflow-tooltip
          width="80"
          align="center"
        >
        </el-table-column>
        <!-- 时间 -->
        <el-table-column
          prop="applyDate"
          :label="$t('assign.updateTime')"
          show-overflow-tooltip
          width="210"
          align="center"
        >
        </el-table-column>
        <!-- 签到记录 -->
        <el-table-column
          prop="cntM,cntD"
          :label="$t('registe.attendanceRecord')"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.cntD }}/{{ scope.row.cntM }}
          </template>
        </el-table-column>
        <!-- 分数 -->
        <el-table-column
          prop="score"
          :label="$t('registe.mark')"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column :label="$t('handle')" fixed="right" align="center" width="290">
          <template slot-scope="scope">
            <!-- 撤销 -->
            <div style="float: left; width: 166px">
              <el-dropdown-item
                @click.native="revoke(scope.row)"
                v-show="scope.row.approvalStatus === '20'"
                style="color: #1c69d3; float: left; padding: 0 0"
                >{{ $t("registe.revoke") }}</el-dropdown-item
              >
            </div>
            <!-- 修改签到记录及分数 -->
            <div style="float: left; width: 166px">
              <el-dropdown-item
                @click.native="updataSignMark(scope.row)"
                v-show="
                  scope.row.passMarkFlag !== '20' &&
                  scope.row.offeringStatus === '40' &&
                  scope.row.approvalStatus !== '40' &&
                  scope.row.signId !== '' &&
                  scope.row.signId !== null &&
                  scope.row.isEdit === '1'
                "
                :disabled="scope.row.cntM === 0"
                style="color: #1c69d3; float: left; padding: 0 0"
                >{{ $t("registe.updataSignMark") }}</el-dropdown-item
              >
            </div>
            <!-- 查看签到记录以及分数 -->
            <div style="float: left; width: 166px">
              <el-dropdown-item
                @click.native="lookSignMark(scope.row)"
                v-show="scope.row.offeringStatus === '40' && scope.row.isEdit === '0' && scope.row.approvalStatus !== '40'"
                :disabled="scope.row.cntM === 0"
                style="color: #1c69d3; float: left; padding: 0 0"
                >{{
                  scope.row.passMarkFlag !== "20"
                    ? $t("registe.lookSignMark")
                    : $t("registe.lookSignMark2")
                }}</el-dropdown-item
              >
            </div>

            <!-- 修改签到记录 -->
            <div style="float: left; width: 166px">
              <el-dropdown-item
                @click.native="updataSign(scope.row)"
                v-show="
                  scope.row.passMarkFlag === '20' &&
                  scope.row.offeringStatus === '40' &&
                  scope.row.approvalStatus !== '40' &&
                  scope.row.signId !== '' &&
                  scope.row.signId !== null &&
                  scope.row.isEdit === '1'
                "
                :disabled="scope.row.cntM === 0"
                style="color: #1c69d3; float: left; padding: 0 0"
                >{{ $t("registe.updataSign") }}</el-dropdown-item
              >
            </div>

            <!-- 查看撤销 -->
            <div style="float: left; width: 166px">
              <el-dropdown-item
                @click.native="revokeView(scope.row)"
                style="color: #1c69d3; float: left; padding: 0 0"
                v-show="scope.row.approvalStatus === '40'"
                >{{ $t("assign.viewrevoke") }}</el-dropdown-item
              >
            </div>
            <!-- 免除 -->
            <div>
              <el-dropdown-item
                @click.native="cancelPenalty(scope.$index, scope.row)"
                v-show="
                  (scope.row.isExistingImmunedRecord === 0 &&
                    scope.row.approvalStatus === '60') ||
                  (scope.row.isExistingImmunedRecord === 0 &&
                    scope.row.approvalStatus === '40')
                "
                style="color: #1c69d3"
                >{{ $t("registe.cancelPenalty") }}</el-dropdown-item
              >
            </div>
            <!-- 已免除 -->
            <div>
              <el-dropdown-item
                @click.native="alreadyImmune(scope.row)"
                style="color: #1c69d3"
                v-show="
                  (scope.row.isExistingImmunedRecord === 1 &&
                    scope.row.approvalStatus === '60') ||
                  (scope.row.isExistingImmunedRecord === 1 &&
                    scope.row.approvalStatus === '40')
                "
                >{{ $t("registe.immune") }}</el-dropdown-item
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      ></el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <replace-user
        v-if="replaceUserVisible"
        ref="replaceUser"
        @refreshDataList="getDataList"
      ></replace-user>
    </div>
    <!--等候名单-->
    <el-dialog
      :title="$t('registe.queryWaitingList')"
      :visible.sync="isShowWaitingList"
      top="5vh"
      class="aui-card-close"
      width="60%"
      :showClose="true"
      :close-on-click-modal="false"
    >
      <el-table
        v-loading="waitingDataListLoading"
        :data="waitingDataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
      >
        <!-- 用户ID -->
        <el-table-column
          prop="userCode"
          header-align="center"
          show-overflow-tooltip
          width="120"
          align="center"
          :label="$t('offering.resource.trainerId')"
        >
        </el-table-column>
        <!-- 员工号 -->
        <el-table-column
          prop="userCardNo"
          header-align="center"
          show-overflow-tooltip
          width="120"
          align="center"
          :label="$t('trainer.userCardNo')"
        >
        </el-table-column>
        <!-- 姓名 -->
        <el-table-column
          prop="userName"
          :label="$t('registe.username')"
          width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- 身份证号 -->
        <el-table-column
          prop="idcard"
          class-name="tableleft"
          label-class-name="tablelabel"
          :label="$t('assign.idNumber')"
          show-overflow-tooltip
          width="150"
          align="center"
        >
        </el-table-column>
        <!-- 审核状态 -->
        <el-table-column
          prop="approvalStatusName"
          :label="$t('assign.signupApprovalStatus')"
          width="150"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- 经销商 -->
        <el-table-column
          prop="orgName"
          :label="$t('registe.company')"
          width="170"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- bba编码 -->
        <el-table-column
          prop="bbaNo"
          width="120"
          align="center"
          show-overflow-tooltip
          :label="$t('assign.bbaNo')"
        >
        </el-table-column>
        <!-- nsc编码 -->
        <el-table-column
          prop="nscNo"
          width="120"
          align="center"
          show-overflow-tooltip
          :label="$t('assign.nscNo')"
        >
        </el-table-column>
        <!-- 主要职位 -->
        <el-table-column
          prop="positionNameCn"
          :label="$t('assign.positionname')"
          width="150"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- 兼职职位1 -->
        <el-table-column
          prop="partTimeJobOne"
          :label="$t('assign.parttimejobone')"
          width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- 兼职职位2 -->
        <el-table-column
          prop="partTimeJobTwo"
          :label="$t('assign.parttimejobtwo')"
          width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <!-- 兼职职位3 -->
        <el-table-column
                prop="partTimeJobThree"
                :label="$t('assign.partTimeJobThree')"
                width="120"
                show-overflow-tooltip
                align="center"
        >
        </el-table-column>
        <!-- 兼职职位4 -->
        <el-table-column
                prop="partTimeJobFour"
                :label="$t('assign.partTimeJobFour')"
                width="120"
                show-overflow-tooltip
                align="center"
        >
        </el-table-column>
        <!-- 兼职职位5 -->
        <el-table-column
                prop="partTimeJobFive"
                :label="$t('assign.partTimeJobFive')"
                width="120"
                show-overflow-tooltip
                align="center"
        >
        </el-table-column>
        <!-- 时间 -->
        <el-table-column
          prop="applyDate"
          :label="$t('assign.time')"
          show-overflow-tooltip
          width="210"
          align="center"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="waitPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="waitLimit"
        :total="waitTotal"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="waitPageSizeChangeHandle"
        @current-change="waitPageCurrentChangeHandle"
      ></el-pagination>
    </el-dialog>

    <!--添加用户-->
    <el-dialog
      :title="$t('registe.adduser')"
      :visible.sync="isShowAddUserForm"
      class="aui-card-close"
      top="5vh"
      width="80%"
      :close-on-click-modal="false"
    >
      <add-user ref="addUser" @onOk="onOk"></add-user>
    </el-dialog>
    <!--失败异常时，调用-->
    <el-dialog
      :title="$t('registe.addusererror')"
      :before-close="handleClose"
      :visible.sync="isShowAddUserFormerror"
      class="aui-card-close"
      top="5vh"
      width="80%"
      :close-on-click-modal="false"
    >
      <add-usererror ref="addUsererror"></add-usererror>
    </el-dialog>
    <!--修改签到记录及分数对话框-->
    <el-dialog
      class="xdjlfs-dialog aui-card-close"
      :title="title"
      :visible.sync="isShowUpdataForm"
      width="73%"
      top="5vh"
      :close-on-click-modal="false"
      :before-close="closeShowUpdataForm"
      @close="closeDialog"
    >
      <div class="el-dialog__header_cus" slot="title">{{ title }}</div>
      <el-form
        :model="dataUpdataForm"
        ref="dataUpdataForm"
        size="mini"
        status-icon="status-icon"
      >
        <div>
          <el-form class="top-form">
            <el-row>
              <!-- 姓名 -->
              <el-col :span="6">
                <el-form-item :label="$t('registe.username') + ':'">
                  <!-- <template slot-scope="scope"> {{scope.row.firstNameCn}}{{scope.row.lastNameCn}} </template> -->
                  <!-- <template>{{dataUpdataForm.firstNameCn}}{{dataUpdataForm.lastNameCn}} </template> -->
                  <template>{{ dataUpdataForm.userNameCn }} </template>
                </el-form-item>
              </el-col>
              <!-- 身份证 -->
              <el-col :span="6">
                <el-form-item :label="$t('user.userCardNo') + ':'">
                  {{ dataUpdataForm.userCardNo }}
                </el-form-item>
              </el-col>
              <!-- 经销商简称 -->
              <el-col :span="6">
                <el-form-item :label="$t('registe.company') + ':'">
                  {{ dataUpdataForm.orgName }}
                </el-form-item>
              </el-col>
              <!-- 主要职位 -->
              <el-col :span="6">
                <el-tooltip
                  :content="dataUpdataForm.positionNameCn"
                  placement="top"
                  effect="light"
                >
                  <el-form-item :label="$t('assign.positionname') + ':'">
                    {{ dataUpdataForm.positionNameCn }}
                  </el-form-item>
                </el-tooltip>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div>
          <el-form class="top-form">
            <el-row>
              <!-- 姓名 -->
              <el-col :span="6">
                <el-tooltip
                  :content="dataUpdataForm.courseNameCn"
                  placement="top"
                  effect="light"
                >
                  <el-form-item label="课程名称:">
                    <!-- <template slot-scope="scope"> {{scope.row.firstNameCn}}{{scope.row.lastNameCn}} </template> -->
                    <!-- <template>{{dataUpdataForm.firstNameCn}}{{dataUpdataForm.lastNameCn}} </template> -->
                    <template>{{ dataUpdataForm.courseNameCn }} </template>
                  </el-form-item>
                </el-tooltip>
              </el-col>
              <!-- 身份证 -->
              <el-col :span="6">
                <el-form-item label="场地名称:">
                  {{ dataUpdataForm.siteName }}
                </el-form-item>
              </el-col>
              <!-- 经销商简称 -->
              <el-col :span="6">
                <el-form-item label="开始时间:">
                  {{ dataUpdataForm.startdate }}
                </el-form-item>
              </el-col>
              <!-- 主要职位 -->
              <el-col :span="6">
                <el-form-item label="结束时间:">
                  {{ dataUpdataForm.enddate }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="center-line"></div>

        <!-- form content -->
        <div v-if="isLooKSignMark" style="height: 20px"></div>
        <el-row>
          <el-form :rules="dataRule" :model="updataForm" ref="updataForm">
            <el-row
              v-if="
                !isLooKSignMark &&
                updataForm.isToday === '0' &&
                updataForm.hasHandwork === '1'
              "
            >
              <div class="checkbox-title">
                <el-checkbox
                  :disabled="!updataForm.isExistHandWork"
                  v-model="updataForm.isChangeStatus"
                  @change="state"
                  >改状态</el-checkbox
                >
              </div>
            </el-row>
            <!-- 改状态 -->
            <el-row
              class="bgc"
              :style="{
                'margin-top':
                  isLooKSignMark ||
                  (updataForm.isToday === '0' && updataForm.hasHandwork === '1')
                    ? '0px'
                    : '24px',
              }"
            >
              <el-col :span="24">
                <!-- 标题 -->
                <div class="temp-top">
                  <div class="tuBiao"></div>
                  <span class="bgc-title">签到记录</span>
                </div>
                <!-- 状态表单相关 容器-->
                <div class="status-container">
                  <!-- 标签相关 -->
                  <div class="tag-wrap">
                    <el-tag
                      id="checkstatus"
                      :type="getColor(item.signStatus)"
                      :key="item.signDetailId"
                      :label="item.signDetailId"
                      effect="plain"
                      @click.native="changeColor(index)"
                      v-for="(item, index) in signData"
                    >
                      第{{ item.signNo }}天
                    </el-tag>
                  </div>
                  <!-- <el-row  style="margin-top:23px;"> -->
                  <!-- <el-col :span="24" class="" v-if="this.isShowScore"> -->
                  <div class="score-container">
                    <!-- 分数 -->
                    <div
                      class="score-wrap"
                      v-if="this.isShowScore"
                      style="margin-right: 10px"
                    >
                      <el-form-item
                        ref="scoreItem"
                        label="分数:"
                        :prop="isValiDataScoreFlag ? 'score' : ''"
                        :key="isValiDataScoreFlag ? 'score' : ''"
                      >
                        <el-input
                          @input="checkAfterStatus"
                          @blur="setStyle"
                          v-model="updataForm.score"
                          maxlength="9"
                          :disabled="isdisable || !updataForm.isChangeStatus"
                          oninput="value=value.replace(/[^\d.]/g,'')"
                        ></el-input>
                      </el-form-item>
                      <div :style="marginObj" ref="score" class="score-tip">
                        及格分数：{{ updataForm.passMarkScore }}分
                      </div>
                    </div>
                    <!-- 查看历史状态修改 -->
                    <div
                      class="score-pop-list"
                      v-if="this.revisionDTOList && this.revisionDTOList.length > 0"
                    >
                      <el-form-item>
                        <el-popover
                          popper-class="new-pop"
                          placement="right"
                          width="600"
                          trigger="click"
                        >
                          <el-row>
                            <el-col
                              :span="24"
                              style="
                                height: 62px;
                                line-height: 62px;
                                text-align: left;
                                font-weight: 700;
                                font-size: 16px;
                                color: rgba(37, 38, 40, 100);
                              "
                            >
                              状态变更履历
                            </el-col>
                          </el-row>
                          <el-table
                            class="new-table"
                            :data="revisionDTOList"
                            style="width: 100%"
                            height="300"
                            :cell-style="cellStyle"
                          >
                            <el-table-column
                              label="修改时间"
                              align="center"
                              show-overflow-tooltip
                              prop="createTime"
                            ></el-table-column>
                            <el-table-column
                              label="操作人"
                              align="center"
                              show-overflow-tooltip
                              prop="creator"
                            ></el-table-column>
                            <el-table-column
                              label="状态修改"
                              align="center"
                              show-overflow-tooltip
                            >
                              <template slot-scope="props">
                                {{ props.row.beforeChange }}-{{ props.row.afterChange }}
                              </template>
                            </el-table-column>
                          </el-table>
                          <span
                            slot="reference"
                            style="
                              color: rgba(28, 105, 212, 100);
                              font-size: 12px;
                              cursor: pointer;
                            "
                            >{{ "查看状态修改变更履历" }}</span
                          >
                        </el-popover>
                      </el-form-item>
                    </div>
                  </div>

                  <!-- </el-col> -->

                  <!-- </el-row> -->
                  <!-- 及格分数展示 -->
                  <!-- <el-row>
                      <el-col :span="12">
                        <el-form-item label="及格分数:" v-if="this.isShowScore" class="pass-score">

                        </el-form-item>
                      </el-col>
                    </el-row> -->
                  <!-- 培训状态展示 -->
                  <div class="status-show-wrap" v-if="!isLooKSignMark">
                    <span>修改前培训记录状态：</span>
                    <span>{{
                      registeapprovalstatus(0, 0, dataUpdataForm.beforeStatus)
                    }}</span>
                    <em></em>
                    <span class="after-change">修改后培训记录状态：</span>
                    <span
                      ><span
                        v-html="dataUpdataForm.afterStatus"
                        :style="{ color: 'rgba(255, 65, 65, 100)' }"
                      ></span
                    ></span>
                  </div>
                  <!-- <el-row>
                      <el-col :span="24" style="display:flex;">

                        <el-form-item label="修改前培训记录状态:" class="before-change">
                          {{
                            registeapprovalstatus(
                              0,
                              0,
                              dataUpdataForm.beforeStatus
                            )
                          }}
                        </el-form-item>

                        <el-form-item
                          style="float:left;"
                          class="after-change"
                          label="修改后培训记录状态:"
                        >
                          <span
                            v-html="dataUpdataForm.afterStatus"
                            style="color: red"
                          ></span>
                        </el-form-item>

                      </el-col>
                    </el-row> -->
                </div>
              </el-col>
            </el-row>
            <div v-if="isLooKSignMark" style="height: 20px"></div>
            <el-row
              v-if="
                !isLooKSignMark &&
                updataForm.isToday === '0' &&
                updataForm.hasHandwork === '1'
              "
            >
              <div class="checkbox-title">
                <el-checkbox
                  style="margin-right: 0px !important"
                  v-model="updataForm.isChangeHandwork"
                  @change="PZ"
                  >改平账</el-checkbox
                >
                <span
                  v-if="updataForm.isExistHandWork"
                  style="
                    width: 1px;
                    height: 12px;
                    margin: -2px 12px;
                    background: rgba(0, 0, 0, 0.1);
                    display: inline-block;
                  "
                ></span>
                <div v-if="updataForm.isExistHandWork" style="display: inline-block">
                  <el-switch
                    v-model="updataForm.isClearHandWork"
                    active-color="#1C69D4"
                    @change="fn"
                    :width="29"
                  >
                  </el-switch>
                  清空平账单
                </div>
                <!-- 开关 -->
              </div>
            </el-row>
            <!-- 右边 -->
            <el-row v-if="!lookPingZhang" :class="isdisableR ? 'disabled-container' : ''">
              <el-col
                :span="24"
                v-if="updataForm.isToday === '0' && updataForm.hasHandwork === '1'"
              >
                <!-- 平账信息 title -->
                <div style="border: 1px solid transparent" class="bgc">
                  <div class="temp-top">
                    <div class="tuBiao"></div>
                    <span class="bgc-title">平账信息</span>
                  </div>
                </div>
                <div class="rightBgc">
                  <!-- <el-form> -->
                  <el-row
                    v-if="updataForm.isToday === '0' && updataForm.hasHandwork === '1'"
                  >
                    <!-- 平账标题 -->
                    <el-col :span="9" style="padding-top: 15px">
                      <div class="pzbt">
                        <el-form-item
                          class="pz-item pz-item-title"
                          label="平账标题："
                          :prop="
                            isdisableR ? '' : 'handworkAccountInfoDTO.balanceAccountTitle'
                          "
                          style="width: 100% !important"
                        >
                          <el-input
                            v-model="
                              updataForm.handworkAccountInfoDTO.balanceAccountTitle
                            "
                            :disabled="isdisableR"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <!-- 单条培训记录需平账金额 -->
                    <el-col :span="15" style="padding-top: 15px">
                      <el-form-item
                        class="pz-item pz-item-records"
                        label="单条培训记录需平账金额："
                        :prop="isdisableR ? '' : 'handworkAccountInfoDTO.amountType'"
                        style="width: 100% !important"
                      >
                        <el-row :gutter="12">
                          <el-col :span="8">
                            <el-select
                              v-model="updataForm.handworkAccountInfoDTO.amountType"
                              placeholder="请选择"
                              :disabled="isdisableR"
                            >
                              <el-option
                                v-for="(item, index) in isSelectData"
                                :key="index"
                                :label="item.name"
                                :value="item.code"
                              >
                              </el-option>
                            </el-select>
                          </el-col>
                          <!-- refs在哪里 -->
                          <el-col :span="16">
                            <!--<el-input-->
                            <!--v-model="-->
                            <!--updataForm.handworkAccountInfoDTO-->
                            <!--.singleAmount-->
                            <!--"-->
                            <!--:disabled="isdisableR"-->
                            <!--oninput="value=value.replace(/[^\d.]/g,'')"-->
                            <!--&gt;</el-input>-->
                            <currency-input
                              v-model="updataForm.handworkAccountInfoDTO.singleAmount"
                              :min="0"
                              :max="99999999.99"
                              :precision="2"
                              :disabled="isdisableR"
                              style="width: 100% !important"
                            ></currency-input>
                          </el-col>
                        </el-row>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!-- 平账说明 -->
                  <el-row
                    v-if="updataForm.isToday === '0' && updataForm.hasHandwork === '1'"
                  >
                    <el-col>
                      <el-form-item class="pz-item pz-item-area" label="平账说明：">
                        <el-input
                          type="textarea"
                          placeholder="请输入内容"
                          v-model="updataForm.handworkAccountInfoDTO.balanceDes"
                          maxlength="1000"
                          show-word-limit
                          :disabled="isdisableR"
                          class="pz-sm"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!-- </el-form> -->
                </div>
              </el-col>
            </el-row>
            <!-- 结算金额下方 -->
            <el-row
              v-if="updataForm.isToday === '0' && updataForm.hasHandwork === '1'"
              style="margin-top: 10px"
            >
              <div class="settled-amount">
                <span class="amount-label">合计结算费用(元)：</span>
                <!-- <span class="amount-label">已结算合计金额(元)：</span> -->
                <el-popover
                  popper-class="new-pop"
                  placement="top-start"
                  width="500"
                  trigger="click"
                >
                  <el-row>
                    <el-col
                      :span="24"
                      style="
                        height: 62px;
                        line-height: 62px;
                        text-align: left;
                        font-weight: 700;
                        font-size: 16px;
                        color: rgba(37, 38, 40, 100);
                      "
                    >
                      结算费用明细
                    </el-col>
                  </el-row>
                  <el-table
                    class="new-table"
                    :data="settledAmountDetail"
                    style="width: 100%"
                    :cell-style="cellStyle"
                  >
                    <el-table-column
                      header-align="center"
                      width="220"
                      label="摘要"
                      align="left"
                      show-overflow-tooltip
                      prop="detail"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      width="105"
                      label="结算费用"
                      align="right"
                      prop="billingPrice"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.billingPrice | formatMoney }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      min-width="130"
                      label="平账编号"
                      align="center"
                      show-overflow-tooltip
                      prop="balanceAccountNo"
                    ></el-table-column>
                  </el-table>
                  <span slot="reference" class="amount-money">{{ settledAmount }}</span>
                </el-popover>
              </div>
            </el-row>
            <!--  平账凭证 -->
            <div
              class="pingzhang"
              style="display: inline-block; width: 400px; position: relative"
            >
              <div style="display: inline-block" v-if="!isLooKSignMark">
                <el-row
                  justify="space-between"
                  v-if="updataForm.isToday === '0'"
                  style="margin-top: 15px"
                >
                  <el-form-item class="pz-item" label="上传凭证：" prop="fileList">
                    <div style="display: inline-block">
                      <el-upload
                        class="upload-demo"
                        ref="upload"
                        :show-file-list="true"
                        :headers="myHeader"
                        :action="uploadUrl"
                        :on-change="uploadChange"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :on-success="handleSuccess"
                        :before-upload="beforeUpload"
                        :file-list="updataForm.fileList"
                        :auto-upload="true"
                        :disabled="isLooKSignMark"
                      >
                        <div>
                          <el-button
                            slot="trigger"
                            type="primary"
                            :class="isLooKSignMark ? 'uploadDisable' : ''"
                            style="font-family: PingFangSC-Regular, sans-serif; margin-right: 10px"
                          >
                            请选择上传的文件
                            <el-tooltip
                              class="item"
                              effect="light"
                              content="单个文件不能超过20MB"
                              placement="top"
                            >
                              <em
                                :style="{ color: isLooKSignMark ? 'grey' : '#fff' }"
                                class="el-icon-question"
                              ></em>
                            </el-tooltip>
                          </el-button>
                        </div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-row>
              </div>
              <div
                :class="isLooKSignMark ? 'looKSignMarkdiv' : 'editSignMarkdiv'"
                v-if="this.hisFileList && this.hisFileList.length > 0"
              >
                <el-form-item>
                  <div style="display: inline-block">
                    <el-popover
                      popper-class="new-pop"
                      placement="right"
                      width="600"
                      trigger="click"
                    >
                      <el-row>
                        <el-col
                          :span="24"
                          style="
                            height: 62px;
                            line-height: 62px;
                            text-align: left;
                            font-weight: 700;
                            font-size: 16px;
                            color: rgba(37, 38, 40, 100);
                          "
                        >
                          历史上传凭证
                        </el-col>
                      </el-row>
                      <el-table
                        class="new-table"
                        :data="hisFileList"
                        style="width: 100%"
                        height="300"
                        :cell-style="cellStyle"
                      >
                        <el-table-column
                          width="180px"
                          label="修改时间"
                          align="center"
                          show-overflow-tooltip
                          prop="createDate"
                        ></el-table-column>
                        <el-table-column
                          width="100px"
                          label="操作人"
                          align="center"
                          show-overflow-tooltip
                          prop="creator"
                        ></el-table-column>
                        <el-table-column
                          min-width="60%"
                          label="文件"
                          align="center"
                          show-overflow-tooltip
                        >
                          <template slot-scope="scope">
                            <span
                              style="color: #409eff; cursor: pointer"
                              @click="downLoadFile(scope.row)"
                              >{{ scope.row.name }}</span
                            >
                          </template>
                        </el-table-column>
                      </el-table>

                      <div
                        slot="reference"
                        :class="isLooKSignMark ? 'looKSignMarkBtn' : 'editSignMarkBtn'"
                      >
                        {{ "查看历史上传凭证" }}
                      </div>
                    </el-popover>
                  </div>
                </el-form-item>
              </div>
            </div>
            <el-row>
              <el-col
                :span="24"
                style="text-align: right; margin-top: 20px"
                :style="{ marginTop: updataForm.isToday === '0' ? '0px' : '20px' }"
              >
                <!-- action 按钮 -->
                <div class="top-size" v-if="!isLooKSignMark">
                  <el-button
                    size="mini"
                    @click="closeShowUpdataForm()"
                    style="color: black !important"
                    :loading="loading"
                    >{{ $t("registe.cancel") }}</el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    @click="submitForm('updataForm')"
                    :loading="loading"
                    >{{ $t("registe.save") }}</el-button
                  >
                </div>
              </el-col>
            </el-row>
          </el-form>
        </el-row>
      </el-form>
    </el-dialog>

    <!--免除按钮对话框-->
    <el-dialog
      title="免除扣款"
      :visible.sync="isShowPenaltyCancelForm"
      class="aui-card-close"
      top="5vh"
      :close-on-click-modal="false"
      :before-close="closeShowPenaltyCancelForm"
    >
      <el-form
        :model="cancelPopUpInfo"
        ref="cancelPopUpInfo"
        size="mini"
        status-icon="status-icon"
      >
        <div>
          <el-form>
            <el-row>
              <!-- 课程 -->
              <el-col :span="24" style="padding-left: 80px; padding-top: 15px">
                <el-form-item :label="$t('registe.coursename') + ':'">
                  {{ courseName }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 排期编号 -->
              <el-col :span="24" style="padding-left: 80px">
                <el-form-item :label="$t('registe.offeringcode') + ':'">
                  {{ dataForm.offeringNo }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <el-form>
            <el-row>
              <!-- 开始时间 -->
              <el-col :span="24" style="padding-left: 20px">
                <el-form-item
                  :label="$t('offering.startdate') + '-' + $t('offering.enddate') + ':'"
                >
                  {{ courseStartDate }}-{{ courseEndDate }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 地点 -->
              <el-col :span="24" style="padding-left: 110px">
                <el-form-item :label="$t('offering.siteNamecan') + ':'">
                  {{ siteName }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 学员 -->
              <el-col :span="24" style="padding-left: 110px">
                <el-form-item :label="$t('registe.apprentice') + ':'">
                  {{ cancelPopUpInfo.userCode }}-{{ cancelPopUpInfo.userName }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 报名时所属公司 -->
              <el-col :span="24" style="padding-left: 40px">
                <el-form-item :label="$t('registe.companyBelong') + ':'">
                  {{ cancelPopUpInfo.companyBelong }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 撤销操作人 -->
              <el-col :span="24" style="padding-left: 70px">
                <el-form-item
                  :label="$t('registe.revokeUserName') + ':'"
                  v-show="this.approvalStatus === '40'"
                >
                  {{ cancelPopUpInfo.revokeUserCode }}-{{
                    cancelPopUpInfo.revokeUserName
                  }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 扣款金额(元) -->
              <el-col :span="24" style="padding-left: 60px">
                <el-form-item :label="$t('registe.penaltyAmount') + ':'">
                  {{ cancelPopUpInfo.noShowPenalty }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <el-form
            label-width="130px"
            label-position="right"
            :model="immuneDataForm"
            :rules="rules"
            ref="immuneDataForm"
          >
            <el-row>
              <!-- 请选择免除原因 取值列表 -->
              <el-col :span="20" style="padding-left: 25px">
                <el-form-item
                  label="免除原因:"
                  prop="immuneReasonFlag"
                  :rules="rules.immuneReasonFlag"
                >
                  <el-select
                    :placeholder="$t('cert.select')"
                    v-model="immuneDataForm.immuneReasonFlag"
                    clearable
                    :disabled="isShowImmune"
                  >
                    <el-option
                      v-for="(item, index) in immunereasonArr"
                      :key="index"
                      :label="item.name"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="height: 10px"></div>
            <el-row>
              <!-- 意见 -->
              <el-col :span="20" style="padding-left: 25px">
                <el-form-item prop="immuneRemark" :rules="rules.immuneRemark">
                  <el-input
                    v-model="immuneDataForm.immuneRemark"
                    type="textarea"
                    placeholder="请填写免除原因"
                    :rows="5"
                    show-word-limit
                    maxlength="500"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="top-size">
              <el-button
                size="mini"
                @click="closeShowPenaltyCancelForm()"
                :loading="loading"
                >{{ $t("registe.cancel") }}</el-button
              >
              <el-button
                size="mini"
                type="primary"
                @click="submitPenaltyImmuneForm()"
                :loading="loading"
                >{{ $t("registe.submission") }}</el-button
              >
            </div>
            <div style="height: 50px"></div>
          </el-form>
        </div>
      </el-form>

      <br />
    </el-dialog>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import addUser from "./addUser";
import numberToCurrencyNo from "@/utils";
import addUsererror from "./addUsererror";
import currencyInput from "./components/currency-input";
import debounce from "lodash/debounce";
import DimissionView from "../../activiti/dimission-view";
// import replaceUser from './replaceuser'
import AesUtil from "@/utils/aes_utils";
export default {
  mixins: [mixinViewModule],
  props: {
    courseCode: null,
  },
  data: function () {
    return {
      // signStatusCache: '', //单独颜色
      // scoreCache: '', //单独缓存分数
      // afterStatusCache: '',//单独缓存后状态
      marginFlag: false,
      // 原始签到记录
      originalSignRecord: undefined,

      txtVal: "0",
      form: {},
      revokeUserName: this.$route.query.revokeUserName,
      approvalStatus: "",
      mixinViewModuleOptions: {
        getDataListIsPage: true,
        getDataListURL: "/learning/offeringregiste/pageMembereList", // 查询列表的url
        getDataListMTURL: "/learning/offeringregiste/pageMembereListMT", // 查询列表的url
        getWaitingDataListURL: "/learning/offeringregiste/RegisteWaiterDetailsList", // 查询等候名单
        getUpdataSignMarkDataListURL: "/learning/offeringregiste/selectSigningList", // 查询签到分数记录
        getSubmitSignMarkDataListURL: "/learning/offeringregiste/updateSigningList", // 提交签到分数记录
        getAllAddDataListURL: "/learning/offeringregiste/getRegisteUserListByOfferid", // 查询所有已添加了的人员名单
        getCancelPopUpInfoURL: "/learning/penaltyrevokehistory/popUpInfo", // 免除弹窗信息展示查询接口
        getCancelUpdateURL: "/learning/penaltyrevokehistory/updatePopUpInfo", // 免除弹窗信息提交接口
        getImmuneInfoURL: "/learning/offeringregiste/immune", // 查询已免除页面信息
      },
      uploadUrl: window.SITE_CONFIG["apiURL"] + "/learning/account/picupload",
      deleteUrl: "/learning/account/picDelete",
      myHeader: { token: "" },
      waitingDataListLoading: false,
      dataList: [],
      waitingDataList: [],
      // 类型
      registeApplyFlagArr: this.enums["registeApplyFlag"],
      dataForm: {
        userName: "", // 姓名
        orgName: "",
        startdate: "", // 开始时间
        enddate: "", // 结束时间
        offeringId: this.$route.query.offeringId,
        offeringNo: this.$route.query.offeringNo,
        isCheck: "0", // 默认不查已撤销的用户
        coursePrice: this.$route.query.coursePrice, // 排期价格
      },
      immuneDataForm: {
        immuneUserId: "",
        immuneAmount: "",
        immuneDate: "",
        immuneUserName: "",
        immuneRemark: "",
        immuneReasonFlag: "",
      },
      // 修改签到记录及分数
      dataUpdataForm: {
        firstNameCn: "", // 姓
        lastNameCn: "", // 名
        idcard: "", // 身份证
        userCardNo: "", // 员工号
        orgName: "", // 经销商简称
        positionNameCn: "", // 主要职位
      },
      // 界面传递信息(传递给替换功能)
      dataofferinginfo: {
        registeId: "", // 报名ID(用于信息传递)
        offeringId: "", // 排期ID
        offeringNo: "", // 排期编号
        courseId: "", // 课程ID
        courseCode: "", // 课程代码
        courseNameCn: "", // 课程名称
        offeringName: "", // 派其名称
        trainerName: "", // 培训师
        siteId: "", // 场地
        startdate: "", // 开始时间
        enddate: "", // 结束时间
      },
      // 免除弹窗信息展示
      cancelPopUpInfo: {
        userCode: "",
        offeringRevokePenaltyDTOList: [],
        courseName: "",
        enddate: "",
        registeAbbreviationCn: "",
        noShowPenalty: "",
        revokeUserName: "",
        courseNameCn: "",
        siteName: "",
        offeringNo: "",
        startdate: "",
        userName: "",
        registeNscNo: "",
        registeBbaNo: "",
        companyBelong: "",
        revokeUserCode: "",
      },
      addForm: {
        userList: [],
      },
      offeringStatus: this.$route.query.offeringStatus,
      allParam: {
        offeringId: this.$route.query.offeringId,
        // rand: new Date()
      },
      updataForm: {
        isExistHandWork: false, //是否存在平账记录
        isClearHandWork: false, //是否清空平账单
        isChangeStatus: true, //状态复选框
        isChangeHandwork: true, //平账复选框
        signId: "",
        registeId: "",
        offeringSignDetailDTOList: [],
        score: "",
        passMarkScore: "",
        statusFirst: "", //变更初始状态
        fileList: [],
        isToday: "", //是否当天
        hasHandwork: "", // 是否手工平账 0-否，1-是
        handworkAccountInfoDTO: {},
        trainingHistoryDTO: {},
        // balanceAccountTitle: '',//平账标题
        // balanceDes: '', // 平账说明
        // amountType:'', //平账类型
        // singleAmount: '' //平账金额
      },
      // 编辑面板的验证规则
      rules: {
        immuneReasonFlag: [
          { required: true, message: "请选择免除原因", trigger: "change" },
        ],
        immuneRemark: [{ required: true, message: "请填写免除原因", trigger: "blur" }],
      },
      penaltyCancelSubmitUserId: null,
      // 等待转圈
      dataListLoading: false,
      isShowWaitingList: false,
      isShowAddUserForm: false,
      isShowAddUserFormerror: false,
      isShowUpdataForm: false,
      isShowPenaltyCancelForm: false,
      isShow: true,
      isShowImmune: false,
      immunereasonArr: this.enums["immuneReasonType"],
      isShowScore: false,
      isdisable: false, // 左边禁用
      isdisableR: false, // 右边禁用
      checkAll: false,
      // 设置按钮pop状态
      visible: false,
      // 是否显示替换用户
      replaceUserVisible: false,
      // activeName2: 'first',
      dateRange: [],
      loading: false,
      isNo: false,
      title: "",
      allAddDataList: [], // 所有已添加了的人员，不带条件查询的
      signData: [], // 签到数据
      courseName: this.$route.query.courseName,
      courseStartDate: this.$route.query.courseStartDate,
      courseEndDate: this.$route.query.courseEndDate,
      siteName: this.$route.query.siteName,
      isFlag: "",
      waitPage: 1, // 等候名单dialog当前页码
      waitLimit: 10, // 等候名单dialog每页数
      waitTotal: 0, // 等候名单dialog总条数deleteURL
      isSelectData: [
        { name: "补缴", code: "10" },
        { name: "退款", code: "20" },
      ],
      isValiDataScoreFlag: true,
      settledAmount: 0, // 已结算金额
      settledAmountDetail: [], // 结算金额明细
      hisFileList: [], //历史上传的平账凭证
      revisionDTOList: [], //历史状态变更
      isLooKSignMark: false, //是否是查看签到记录以及分数状态
      LooKmargin: false, //及格分数边距
      lookPingZhang: false,
    };
  },
  computed: {
    marginObj(signStatus) {
      if (!this.isLooKSignMark) {
        if (this.isdisable || !this.updataForm.isChangeStatus) {
          return { "margin-left": "44px" };
        } else {
          return { "margin-left": "54px" };
        }
      } else {
        if (this.LooKmargin) {
          return { "margin-left": "54px" };
        } else {
          return { "margin-left": "44px" };
        }
      }
    },
    stateNumber() {
      if (this.updataForm.isToday === "0" && this.updataForm.hasHandwork === "1") {
        return 12;
      } else {
        return 24;
      }
    },
    dataRule() {
      var _this = this;
      return {
        score: [
          { required: true, message: "请输入分数", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (value < 0 || value > 100) {
                callback(new Error("请输入正确的分数"));
              }
              if (/(^[0-9]+(\.[0-9]{1})?$)/.test(value)) {
                callback();
              } else {
                callback(new Error("请输入正确的分数"));
              }
            },
            trigger: "blur",
          },
        ],
        fileList: [
          { required: true, message: "请上传凭证", trigger: "change" },
          {
            validator(rule, value, callback) {
              if (!(value instanceof Array) || value.length <= 0) {
                callback(new Error("请上传凭证"));
              }
              callback();
            },
            trigger: "change",
          },
        ],
        "handworkAccountInfoDTO.balanceAccountTitle": [
          { required: true, message: "请输入平账标题", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (!value) {
                callback(new Error("请输入平账标题"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        "handworkAccountInfoDTO.amountType": [
          { required: true, message: "请输入类型", trigger: "change" },
          {
            required: true,
            validator(rule, value, callback) {
              // debugger
              console.log(
                _this.updataForm.handworkAccountInfoDTO.singleAmount,
                "---------------------"
              );
              if (!value) {
                callback(new Error("请输入类型"));
              } else {
                if (!_this.updataForm.handworkAccountInfoDTO.singleAmount) {
                  callback(new Error("请输入平账金额"));
                } else {
                  if (_this.updataForm.handworkAccountInfoDTO.singleAmount <= 0) {
                    callback(new Error("平账金额需大于0"));
                  }
                  callback();
                }
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      };
    },
  },
  components: {
    DimissionView,
    // replaceUser
    "add-user": addUser,
    "add-usererror": addUsererror,
    currencyInput,
  },
  created() {
    /* eslint-disable */
    // debugger
    // console.log("---------",this.enums)
  },
  watch: {
    // 'updataForm.score': function (newVal, oldVal) {
    //   // 保留两位小数
    //   if (newVal) {
    //     newVal = newVal.toString();
    //     console.log(newVal)
    //     console.log(newVal <= 100)
    //     var pointIndex = newVal.indexOf('.');
    //     if(newVal >= 100){
    //       this.updataForm.score = 100;
    //       return;
    //     }else if (pointIndex > 0 && (newVal.length - pointIndex) > 2){
    //       this.updataForm.score = oldVal;
    //       return;
    //     }
    //   }
    // }
  },
  methods: {
    // 处理分数校验不通过
    setStyle() {
      this.$nextTick(() => {
        // 校验不通过 样式问题
        setTimeout(() => {
          if (this.$refs.scoreItem.$el.classList.contains("is-error")) {
            this.$refs.score.style.marginTop = "15px";
          } else {
            this.$refs.score.style.marginTop = "5px";
          }
        }, 0);
      });
    },
    formatMoney(num) {
      if (!num && num !== 0 && num !== "0") {
        return "";
      }
      num = num.toString().replace(/\$|\,/g, "");
      if (isNaN(num)) {
        num = "0";
      }
      let sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      let cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) {
        cents = "0" + cents;
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num =
          num.substring(0, num.length - (4 * i + 3)) +
          "," +
          num.substring(num.length - (4 * i + 3));
      }
      return (sign ? "" : "-") + num + "." + cents;
    },
    fn() {
      if (this.updataForm.isClearHandWork && this.updataForm.isChangeHandwork) {
        this.updataForm.isChangeHandwork = false;
        this.PZ();
      }
    },
    state() {
      // 改状态点击事件
      if (!this.updataForm.isChangeStatus) {
        // 清空分数的校验
        this.$refs["updataForm"].clearValidate(["score"]);
        // 禁用分数
        this.isdisable = true;
        // 处理分数不校验问题  当dialog来回切 该值没有isValiDataScoreFlag变 导致的
        // 分数必填标识
        this.isValiDataScoreFlag = false;
        // this.updataForm.score= this.scoreCache
        // this.dataUpdataForm.afterStatus = this.afterStatusCache
        // this.signData[0].signStatus = this.signStatusCache
        // 还原分数
        this.updataForm.score = JSON.parse(JSON.stringify(this.originalSignRecord.score));
        // 还原修改后状态
        this.dataUpdataForm.afterStatus = JSON.parse(
          JSON.stringify(
            this.registeapprovalstatus(0, 0, this.originalSignRecord.afterStatus)
          )
        );
        //还原签到记录
        this.signData = JSON.parse(
          JSON.stringify(this.originalSignRecord.offeringSignDetailDTOList)
        );
      }
      let _this = this;
      // 禁用分数
      _this.isdisable = false;
      // 分数必填标识
      _this.isValiDataScoreFlag = true;
      for (let i = 0; i < _this.signData.length; i++) {
        // 如果有未签到的不允许修改分数
        if (
          _this.signData[i].signStatus === "10" ||
          _this.signData[i].signStatus === "30"
        ) {
          // 禁用分数
          _this.isdisable = true;
          // 分数必填标识
          _this.isValiDataScoreFlag = false;
          continue;
        }
      }

      // this.$refs.updataForm.resetFields()// 移除校验
    },
    PZ() {
      if (!this.updataForm.isChangeHandwork) {
        // 只移除平账标题和平账类型、金额的校验
        this.$refs["updataForm"].clearValidate([
          "handworkAccountInfoDTO.balanceAccountTitle",
        ]);
        this.$refs["updataForm"].clearValidate(["handworkAccountInfoDTO.amountType"]);
        this.isdisableR = true;
        this.updataForm.handworkAccountInfoDTO = JSON.parse(
          JSON.stringify(this.originalSignRecord.handworkAccountInfoDTO)
        );
      } else {
        this.isdisableR = false;
        // 如果清空平账单勾选，则取消勾选
        if (this.updataForm.isClearHandWork) {
          this.updataForm.isClearHandWork = false;
        }
      }
    },
    // 重置表数据
    initDiallogFormData() {
      (this.updataForm = {
        isExistHandWork: false, //是否存在平账记录
        isClearHandWork: false, //是否清空平账单
        isChangeStatus: true, //状态复选框
        isChangeHandwork: true, //平账复选框
        signId: "",
        registeId: "",
        offeringSignDetailDTOList: [],
        score: "",
        passMarkScore: "",
        statusFirst: "", //变更初始状态
        fileList: [],
        isToday: "", //是否当天
        hasHandwork: "", // 是否手工平账 0-否，1-是
        handworkAccountInfoDTO: {},
        trainingHistoryDTO: {},
      }),
        (this.isdisableR = false);
      this.hisFileList = [];
      this.revisionDTOList = [];
      this.isLooKSignMark = false; //是否是查看签到记录以及分数状态
      this.LooKmargin = false; //及格分数边距
      this.lookPingZhang = false;
    },
    closeDialog() {
      //弹框关闭
      this.$refs.updataForm.resetFields(); // 移除校验
      // this.$refs.updataFormRight.resetFields(); // 移除校验
    },
    cellStyle() {
      console.log('cellStyle')
    },
    uploadChange(file, fileList) {
      if (fileList.length && fileList.length > 0) {
        this.$refs["updataForm"].validateField("fileList");
      }
    },
    handlePreview(file) {
      console.log(file);
      if (
        this.updataForm.fileList === "" ||
        this.updataForm.fileList === null ||
        this.updataForm.fileList === undefined
      ) {
        this.$message({
          message: "请先上传文件",
          type: "error",
          duration: 1500,
        });
      } else {
        this.$message({
          message: this.$t("user.authApplyDownloadFileMessage"),
          type: "info",
          duration: 1000,
        });
        this.$request.downloadBigFile(
          "/learning/account/picDownload",
          // this.$request.download('/sys/commAdminFileManagement/downloadFile',
          file.name,
          {
            url: file.url,
            name: file.name,
          },
          null,
          false
        );
      }
    },
    handleRemove(file, fileList) {
      if (file && file.status === "success") {
        if (this.$route.query.id !== undefined) {
          // 1.获取将要删除图片的临时路径
          let filePath = file.response ? file.response.data.tmp_path : file.url;
          // 2.从pics数组中，找到图片对应的索引值
          let i = this.updataForm.fileList.findIndex((x) => x.url === filePath);
          // 3.调用splice方法，移除图片信息
          this.updataForm.fileList.splice(i, 1);
        } else {
          this.$request
            .post(this.deleteUrl, file)
            .then((res, total, code, data) => {
              if (data.code == 1) {
                // 1.获取将要删除图片的临时路径
                let filePath = file.response ? file.response.data.tmp_path : file.url;
                // 2.从pics数组中，找到图片对应的索引值
                let i = this.updataForm.fileList.findIndex((x) => x.url === filePath);
                // 3.调用splice方法，移除图片信息
                this.updataForm.fileList.splice(i, 1);
              }
            })
            .catch(() => {
              this.dataListLoading = false;
            });
        }
      }
    },
    // 上传成功
    handleSuccess(response, file, fileList) {
      if (response.code === 200) {
        let id = file.uid;
        let i = fileList.findIndex((x) => x.uid === id);
        fileList.splice(i, 1);
        this.$message({
          message: response.msg,
          type: "error",
          duration: 1500,
        });
      } else {
        this.updataForm.fileList.push({
          name: response.data.certificateName,
          url: response.data.certificatePath,
          id: response.data.certificateId,
        });
        file.name = response.data.certificateName;
        file.url = response.data.certificatePath;
        file.id = response.data.certificateId;
        if (response.code !== 1) {
          this.handleRemove(file, this.updataForm.fileList);
          this.$message({
            message: response.msg,
            type: "error",
            duration: 1500,
          });
        } else {
          this.$message({
            message: "上传成功",
            type: "success",
            duration: 1500,
          });
        }
        // if (response.code !== 1) {
        //   this.$message({
        //     message: response.msg,
        //     type: "error",
        //     duration: 1500,
        //   });
        // } else {
        //   this.updataForm.fileList.push({
        //     name: response.data.certificateName,
        //     url: response.data.certificatePath,
        //     id: response.data.certificateId,
        //   });
        //   this.$message({
        //     message: "上传成功",
        //     type: "success",
        //     duration: 1500,
        //   });
        // }
      }
    },
    beforeUpload(file, fileList) {
      if (file == null) {
        this.$message({
          message: "请先上传文件",
          type: "error",
          duration: 1500,
          // onClose: () => {
          //     this.getDataList()
          // }
        });
        return false;
      }
      if (/.+\.exe$/.test(file.name)) {
        this.$message({
          message: "禁止上载exe文件",
          type: "error",
          duration: 1500,
        });
        return false;
      }
      let maxLength = 20 * 1024 * 1024;
      if (file.size > maxLength) {
        this.$message({
          message: "文件大小不能超过20M",
          type: "error",
          duration: 1500,
        });
        return false;
      }
      return true;
    },
    handleClose(done) {
      let _this = this;
      this.isShowAddUserForm = false;
      done();
      // _this.selectTable = vehicleData
      _this.getDataListMerge();
      console.log("<<<<<<<<<<<关闭结束");
    },
    descInput() {
      this.txtVal = this.dataForm.immuneRemark.length;
    },
    // handleClick2 (tab, event) {
    //   // alert(tab.name);
    //   if (tab.name === 'three') {
    //   // this.$refs.unbundling.onQuery();
    //   }
    // },
    // 调用已免除查看已免除页面
    alreadyImmune(row) {
      /* eslint-disable */
      // debugger
      // this.$request.post(this.mixinViewModuleOptions.getImmuneInfoURL, { registeId: row.registeId, userId: row.userId, offeringId: row.offeringId,immuneUserName:'' }).then((res, total, code, data) => {
      //     console.log(data)
      // })

      this.$router.push({
        name: "learning-course-registe-immuneuser",
        query: {
          registeId: row.registeId,
          approvalStatus: row.approvalStatus,
          userId: row.userId,
          offeringId: row.offeringId,
          showCheck: true,
          showCheckUser: true,
          offeringNo: this.dataForm.offeringNo,
          registeAbbreviation: row.registeAbbreviation,
          revokeUserName: row.revokeUserName,
          registeNscNo: row.registeNscNo,
          registeBbaNo: row.registeBbaNo,
          registeAbbreviationCn: row.registeAbbreviationCn,
          userCode: row.userCode,
          revokeUserCode: row.revokeUserCode,
          immuneUserId: this.dataForm.immuneUserId,
        },
      });
    },
    isCheck() {
      // let _this = thisƒ√
      if (this.isNo) {
        this.dataForm.isCheck = "1"; // 查询条件赋值
      } else {
        this.dataForm.isCheck = "0";
      }
      this.getDataListMerge(); // 调查询方法事件
    },
    // 返回颜色
    getColor(signStatus) {
      if ("20".indexOf(signStatus) === -1 && "40".indexOf(signStatus) === -1) {
        this.LooKmargin = false;
        return "danger";
      } else {
        this.LooKmargin = true;
        return "success";
      }
    },
    changeColor(index) {
      if (this.isLooKSignMark) {
        return;
      }
      if (this.updataForm.isChangeStatus) {
        if (
          "10".indexOf(this.signData[index].signStatus) === -1 &&
          "30".indexOf(this.signData[index].signStatus) === -1
        ) {
          this.signData[index].signStatus = "10";
        } else {
          this.signData[index].signStatus = "40";
        }
        if ("1".indexOf(this.signData[index].isChange) === -1) {
          this.signData[index].isChange = "1";
        } else {
          this.signData[index].isChange = "0";
        }
        for (let i = 0; i < this.signData.length; i++) {
          // debugger
          // 如果有未签到的不允许修改分数
          if (
            this.signData[i].signStatus === "10" ||
            this.signData[i].signStatus === "30"
          ) {
            // 清空分数的校验
            this.$refs["updataForm"].clearValidate(["score"]);
            this.isdisable = true;
            // this.$refs['updataForm'].resetFields();
            // 不校验分数
            this.isValiDataScoreFlag = false;
            this.updataForm.score = "";
            this.checkAfterStatus();

            return;
          } else {
            // 清空分数的校验
            this.$refs["updataForm"].clearValidate(["score"]);
            //// 不校验分数校验分数
            this.isValiDataScoreFlag = true;
            this.isdisable = false;
          }
        }
        this.checkAfterStatus();
        this.$forceUpdate();
      }
    },
    // 校验状态
    checkAfterStatus() {
      window.setTimeout(() => {
        this.updataForm.offeringSignDetailDTOList = this.signData;
        this.$request
          .post("/learning/offeringregiste/checkAfterStatus", this.updataForm)
          .then((res, total, code, data) => {
            this.$nextTick(() => {
              if (data.code === 13000000) {
                this.$message({
                  message: data.msg,
                  type: "error",
                  duration: 5000,
                  onClose: () => {
                    console.log('onClose')
                  },
                });
                return;
              }
              this.dataUpdataForm.afterStatus = this.registeapprovalstatus(
                0,
                0,
                data.data.afterStatus
              );
              // 如果当前状态和初始状态相等，则清空平账单改为true
              if (
                this.updataForm.statusFirst === data.data.afterStatus &&
                !this.updataForm.isClearHandWork
              ) {
                this.updataForm.isClearHandWork = true;
                this.fn();
                this.$message({
                  type: "warning",
                  message: "将变更回初始培训记录状态，清空平账单功能已开启",
                  duration: 2000,
                });
              }
              this.$forceUpdate();
            });
          })
          .catch(function (error) {
            //this.$message.error(this.$t("errorCode." + json.reason, data.message));
          });
      }, 1000);
    },
    // 查询
    getDataListMerge() {
      // debugger
      this.page = 1;
      let d = new Date();
      // 由于日期区间是2个国际标准的时间字符串显示进行了下面的判断和转换
      if (this.dateRange === null || this.dateRange.length === 0) {
      } else {
        // 区间的开始日期默认00:00:00
        d = new Date(this.dateRange[0]);
        let start1 =
          d.getFullYear() +
          "-" +
          this.checkTime(d.getMonth() + 1) +
          "-" +
          this.checkTime(d.getDate()) +
          " 00:00:00";
        // 区间的结束日期默认23:59:59
        d = new Date(this.dateRange[1]);
        let start2 =
          d.getFullYear() +
          "-" +
          this.checkTime(d.getMonth() + 1) +
          "-" +
          this.checkTime(d.getDate()) +
          " 23:59:59";
        this.dataForm.startdate = start1;
        this.dataForm.enddate = start2;
      }
      this.getDataList();
    },
    dateFormat(row, column, cellValue) {
      var datetime = cellValue;
      if (datetime) {
        datetime = new Date(datetime);
        let y = datetime.getFullYear() + "-";
        let mon = datetime.getMonth() + 1 + "-";
        let d = datetime.getDate();
        return y + mon + d;
      }
      return "";
    },
    checkTime(i) {
      // 这是时间格式化时一位数补充0的处理
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    // 重置
    again() {
      this.showVehicleClassList = "";
      this.dataForm = {
        offeringId: this.allParam.offeringId, // 排期ID
        userName: "", // 姓名
        orgName: "",
        startdate: "", // 开始时间
        enddate: "", // 结束时间
        isCheck: "0",
      };
      this.isNo = false;
      this.dateRange = [];
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      /* eslint-disable */
      // debugger
      const base64url = require("base64-url");
      let aes = new AesUtil();
      let userName = "";
      if (this.dataForm.userName === "") {
        userName = "";
      } else {
        userName = base64url.encode(aes.encrypt(this.dataForm.userName + ""));
      }

      let newDataForm = JSON.parse(JSON.stringify(this.dataForm));

      newDataForm.userName = userName;
      newDataForm.offeringId = this.allParam.offeringId;
      if ("regionIds" in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = "";
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(",");
        }
      }
      this.dataListLoading = true;
      this.$request
        .get(this.mixinViewModuleOptions.getDataListMTURL, {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm,
        })
        .then((res, total, code, data) => {
          let resultList = data.data.records;
          // this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? data.result.list : resultList
          this.dataList = resultList;
          this.total = this.mixinViewModuleOptions.getDataListIsPage
            ? data.data.total
            : 0;
          // 延迟加载
          this.$nextTick(() => {
            // this.querSelect()
            this.dataListLoading = false;
          });
        })
        .catch(() => {
          this.dataListLoading = false;
        });
      this.$request
        .get(this.mixinViewModuleOptions.getAllAddDataListURL, {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...this.allParam,
        })
        .then((res, total, code, data) => {
          let resultList = data.data;
          this.allAddDataList = resultList;
          // this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.data.total : 0
          // 延迟加载
          this.$nextTick(() => {
            // this.querSelect()
          });
          this.$forceUpdate();
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    // 获取所有已添加了的人员名单
    // async getAllAddDataList () {
    //   let _this = this
    //   _this.dataListLoading = true
    //   await _this.$request.get(
    //     _this.mixinViewModuleOptions.getAllAddDataListURL,
    //     {
    //       order: this.order,
    //       orderField: this.orderField,
    //       page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
    //       limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
    //       ...this.allParam
    //     }
    //   ).then((res, total, code, data) => {
    //     _this.dataListLoading = false
    //     let resultList = data.data
    //     _this.allAddDataList = resultList
    //     this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.data.total : 0
    //     // 延迟加载
    //     this.$nextTick(() => {
    //       // this.querSelect()
    //     })
    //   }).catch(() => {
    //     this.dataListLoading = false
    //   })
    // },
    // 添加用户
    adduser() {
      // this.getAllAddDataList()
      let allDataList = this.allAddDataList;
      this.isShowAddUserForm = true;
      console.log(
        this.dataForm.offeringId + ">>>>>>>>>排期价格" + this.dataForm.coursePrice
      );
      this.$nextTick(() => {
        (this.$refs.addUser.parentData = allDataList), // 将所有已添加的人员传给子组件
          this.$refs.addUser.again(),
          (this.$refs.addUser.dataForm.offeringId = this.dataForm.offeringId),
          (this.$refs.addUser.dataForm.coursePrice = this.dataForm.coursePrice),
          (this.$refs.addUser.dataForm.offeringendDate = this.courseEndDate),
          this.$refs.addUser.queryVehiclerela(allDataList),
          this.$refs.addUser.initMethods(),
        (this.$refs.addUser.courseName = this.courseName),
          (this.$refs.addUser.courseStartDate = this.courseStartDate),
          (this.$refs.addUser.courseEndDate = this.courseEndDate),
          (this.$refs.addUser.siteName = this.siteName),
          (this.$refs.addUser.coursePrice = this.dataForm.coursePrice);
      });
    },
    onOk(vehicleData, isChecked) {
      /* eslint-disable */
      // debugger

      let _this = this;
      let url = "";
      let param = "";
      url = "/learning/offeringregiste/insertPersonnelList";
      param = {
        offeringId: this.dataForm.offeringId,
        selectList: vehicleData,
        isChecked: isChecked,
      };
      _this.$request
        .post(url, param)
        .then((res, total, code, data) => {
          if (null != data.data) {
            _this.$refs.addUser.subloading = false;
            this.$message.error(data.data);
          } else {
            _this.$message({
              message: _this.$t("prompt.success"),
              type: "success",
              duration: 500,
            });
            _this.isShowAddUserForm = false;
            _this.selectTable = vehicleData;
            _this.getDataListMerge();
          }

          //失败时，显示掉用失败页面*****************************************
          // let code=data.code
          if (data.code === 1) {
            console.log(">>>>>>>>>>>>>>" + data.code);
            let date = data.data; //[{'userCode':'a1',"status":'成功'},{'userCode':'a2',"status":'失败'}]  //data.data//data.data//
            console.log(
              this.dataForm.offeringId + ">>>>>>>>>排期价格" + this.dataForm.coursePrice
            );
            let errotc = 0;
            let sucesscoun = 0;
            if (date != null) {
              date.forEach(function (item) {
                console.log(">>>>>>>>>>>>>>" + item.status);
                if (item.status == false) {
                  errotc = errotc + 1;
                } else {
                  sucesscoun = sucesscoun + 1;
                }
              });
            }
            if (errotc > 0) {
              // 为 展示页面
              this.isShowAddUserFormerror = true;
              this.$nextTick(() => {
                console.log("1>>>>>>>>>>>>>>" + errotc);
                console.log("sucesscoun>>>>>>>>>>>>>>" + sucesscoun);
                this.$refs.addUsererror.successcount = sucesscoun;
                this.$refs.addUsererror.errorcount = errotc;
                this.$refs.addUsererror.again(date);
              });
              this.isShowAddUserFormerror = true;
            } else {
              //成功部分
              _this.$message({
                message: _this.$t("prompt.success"),
                type: "success",
                duration: 500,
              });
              _this.isShowAddUserForm = false;
              _this.selectTable = vehicleData;
              _this.getDataListMerge();
            }
            // _this.getAllAddDataList()
          }
        })
        .catch(function (error) {
          _this.$refs.addUser.subloading = false;
        });
    },
    // 免除
    cancelPenalty(index, row) {
      this.form = row;
      console.log(this.form);
      console.log(row);
      this.submitRegisteId = row.registeId;
      this.cancelPopUpInfo.userName = row.userName;
      this.cancelPopUpInfo.userCode = row.userCode;
      this.cancelPopUpInfo.orgName = row.orgName;
      this.penaltyCancelSubmitUserId = row.userId;
      this.$request
        .get(this.mixinViewModuleOptions.getCancelPopUpInfoURL, {
          registeId: row.registeId,
        })
        .then((res, total, code, data) => {
          // 获取整数部分
          const intPart = Math.trunc(data.data.noShowPenalty);
          // 整数部分处理，增加,
          const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          // 预定义小数部分
          let floatPart = "00";
          // 将数值截取为小数部分和整数部分
          const valueArray = data.data.noShowPenalty.toString().split(".");
          if (valueArray.length === 2) {
            // 有小数部分
            floatPart = valueArray[1].toString(); // 取得小数部分
          }

          this.$set(
            this.cancelPopUpInfo,
            "noShowPenalty",
            intPartFormat + "." + floatPart
          );
          this.$set(this.cancelPopUpInfo, "revokeUserName", data.data.revokeUserName);
          this.$set(
            this.cancelPopUpInfo,
            "registeAbbreviationCn",
            data.data.registeAbbreviationCn
          );
          this.$set(this.cancelPopUpInfo, "registeNscNo", data.data.registeNscNo);
          this.$set(this.cancelPopUpInfo, "registeBbaNo", data.data.registeBbaNo);

          if (
            data.data.registeBbaNo === "" ||
            data.data.registeBbaNo === null ||
            data.data.registeBbaNo === undefined
          ) {
            this.$set(
              this.cancelPopUpInfo,
              "companyBelong",
              data.data.registeAbbreviationCn
            );
          } else {
            this.$set(
              this.cancelPopUpInfo,
              "companyBelong",
              data.data.registeBbaNo +
                "_" +
                data.data.registeNscNo +
                "_" +
                data.data.registeAbbreviationCn
            );
          }

          this.$set(this.cancelPopUpInfo, "revokeUserCode", data.data.revokeUserCode);

          console.log("免除");
          console.log(this.cancelPopUpInfo);
        })
        .catch((err) => {
          console.log(err)
        });
      this.approvalStatus = row.approvalStatus;
      this.isShowPenaltyCancelForm = true;
      // this.rowTable = Object.assign({}, row);
      // this.rowTable.index=index;
    },
    // 修改签到记录和分数
    updataSignMark(row) {
      this.initDiallogFormData();
      /* eslint-disable */
      // debugger
      var _this = this;
      _this.isdisable = false;
      _this.$request
        .post(_this.mixinViewModuleOptions.getUpdataSignMarkDataListURL, {
          offeringId: _this.dataofferinginfo.offeringId,
          userId: row.userId,
          registeId: row.registeId,
        })
        // .then(function (res) {
        //   // alert(JSON.stringify(res));
        //   if (res.data.msg == "success") {
        //     _this.signData = res.data.data.offeringSignDetailDTOList
        //     _this.isShowUpdataForm = true;
        //   }
        // })
        .then((res, total, code, data) => {
          if (data.msg == "success") {
            _this.signData = data.data.offeringSignDetailDTOList;
            _this.title = "修改签到记录及分数";
            _this.isFlag = "1";
            _this.isShowScore = true;

            _this.isShowUpdataForm = true;

            // 默认都为true
            _this.isValiDataScoreFlag = true;
            //
            // this.$refs['dataRule'].resetFields();
            for (let i = 0; i < _this.signData.length; i++) {
              // 如果有未签到的不允许修改分数
              if (
                _this.signData[i].signStatus === "10" ||
                _this.signData[i].signStatus === "30"
              ) {
                _this.isdisable = true;
                _this.isValiDataScoreFlag = false;
                continue;
              }
            }
            _this.dataUpdataForm.firstNameCn = data.data.firstNameCn; // 姓名
            _this.dataUpdataForm.lastNameCn = data.data.lastNameCn; // 姓名
            _this.dataUpdataForm.userNameCn = data.data.userNameCn; // 姓名
            _this.dataUpdataForm.idcard = data.data.idcard; // 身份证
            _this.dataUpdataForm.userCardNo = data.data.userCardNo; // 员工号
            _this.dataUpdataForm.orgName = data.data.orgName; // 经销商简称
            _this.dataUpdataForm.positionNameCn = data.data.positionNameCn; // 主要职位

            if (data.data.fileList) {
              this.updataForm.fileList = data.data.fileList;
            }
            // this.updataForm.fileList = data.data.fileList;
            // console.info(this.updataForm.fileList);
            _this.dataUpdataForm.courseNameCn = data.data.courseNameCn;
            _this.dataUpdataForm.siteName = data.data.siteName;
            _this.dataUpdataForm.startdate = data.data.startdate;
            _this.dataUpdataForm.enddate = data.data.enddate;
            _this.dataUpdataForm.beforeStatus = data.data.beforeStatus;
            _this.originalSignRecord = JSON.parse(JSON.stringify(data.data));

            // this.afterStatusCache = this.registeapprovalstatus(
            //   0,
            //   0,
            //   data.data.afterStatus
            // );//单独缓存

            _this.dataUpdataForm.afterStatus = _this.registeapprovalstatus(
              0,
              0,
              data.data.afterStatus
            );
            _this.updataForm.score = data.data.score; // 分数
            _this.updataForm.passMarkScore = data.data.passMarkScore;
            _this.updataForm.statusFirst = data.data.statusFirst;
            // this.scoreCache = data.data.score; // 缓存分数
            _this.updataForm.registeId = data.data.registeId; // 报名ID
            _this.updataForm.signId = data.data.signId; // 签到ID
            _this.updataForm.isToday = data.data.isToday;
            _this.updataForm.hasHandwork = data.data.hasHandwork;
            // this.updataForm.isToday = '1'; //测试
            // this.updataForm.hasHandwork = '1'; //测试
            _this.updataForm.handworkAccountInfoDTO = data.data.handworkAccountInfoDTO;
            if (data.data.handworkAccountInfoDTO) {
              _this.updataForm.isExistHandWork = data.data.handworkAccountInfoDTO.id
                ? true
                : false;
            }
            _this.hisFileList = data.data.hisFileList;
            _this.revisionDTOList = data.data.revisionDTOList;
            _this.updataForm.trainingHistoryDTO = data.data.trainingHistoryDTO;
            _this.$nextTick(() => {
              _this.$refs["updataForm"].clearValidate(); // 移除校验
            });
            // 查询平账金额
            _this.querySettledAmount();
            // this.updataForm.balanceAccountTitle = data.data.handworkAccountInfoDTO?data.data.handworkAccountInfoDTO.balanceAccountTitle:""
            // this.updataForm.balanceDes = data.data.handworkAccountInfoDTO?data.data.handworkAccountInfoDTO.balanceDes:""
            // this.updataForm.amountType = data.data.handworkAccountInfoDTO?data.data.handworkAccountInfoDTO.amountType:""
            // this.updataForm.singleAmount = data.data.handworkAccountInfoDTO?data.data.handworkAccountInfoDTO.singleAmount:""
          }
          // if (this.updataForm.score !== null && '' !== this.updataForm.score) {
          //   _this.isShow = true
          // }
        })
        .catch(function (error) {
          _this.$message.error('服务器异常');
        });
    },
    //查看签到记录以及分数
    lookSignMark(row) {
      this.initDiallogFormData();
      /* eslint-disable */
      this.isdisable = true;
      this.isdisableR = true;
      //处于查看签到记录以及分数状态
      this.isLooKSignMark = true;
      this.$request
        .post(this.mixinViewModuleOptions.getUpdataSignMarkDataListURL, {
          offeringId: this.dataofferinginfo.offeringId,
          userId: row.userId,
          registeId: row.registeId,
        })
        .then((res, total, code, data) => {
          if (data.msg == "success") {
            this.signData = data.data.offeringSignDetailDTOList;
            //console.log(data.data.offeringSignDetailDTOList)
            this.title = "查看签到记录及分数";
            this.isFlag = "1";

            if (row.passMarkFlag === "20") {
              this.isShowScore = false;
              this.title = "查看签到记录";
            } else {
              this.isShowScore = true;
              this.title = "查看签到记录及分数";
            }

            this.isShowUpdataForm = true;

            // 默认都为true
            this.isValiDataScoreFlag = true;
            //
            // this.$refs['dataRule'].resetFields();
            for (let i = 0; i < this.signData.length; i++) {
              // 如果有未签到的不允许修改分数
              if (
                this.signData[i].signStatus === "10" ||
                this.signData[i].signStatus === "30"
              ) {
                this.isdisable = true;
                this.isValiDataScoreFlag = false;
                continue;
              }
            }
            this.dataUpdataForm.firstNameCn = data.data.firstNameCn; // 姓名
            this.dataUpdataForm.lastNameCn = data.data.lastNameCn; // 姓名
            this.dataUpdataForm.userNameCn = data.data.userNameCn; // 姓名
            this.dataUpdataForm.idcard = data.data.idcard; // 身份证
            this.dataUpdataForm.userCardNo = data.data.userCardNo; // 员工号
            this.dataUpdataForm.orgName = data.data.orgName; // 经销商简称
            this.dataUpdataForm.positionNameCn = data.data.positionNameCn; // 主要职位

            if (data.data.fileList) {
              this.updataForm.fileList = data.data.fileList;
            }
            // this.updataForm.fileList = data.data.fileList;
            // console.info(this.updataForm.fileList);
            this.dataUpdataForm.courseNameCn = data.data.courseNameCn;
            this.dataUpdataForm.siteName = data.data.siteName;
            this.dataUpdataForm.startdate = data.data.startdate;
            this.dataUpdataForm.enddate = data.data.enddate;
            this.dataUpdataForm.beforeStatus = data.data.beforeStatus;
            this.originalSignRecord = JSON.parse(JSON.stringify(data.data));

            // this.afterStatusCache = this.registeapprovalstatus(
            //   0,
            //   0,
            //   data.data.afterStatus
            // );//单独缓存

            this.dataUpdataForm.afterStatus = this.registeapprovalstatus(
              0,
              0,
              data.data.afterStatus
            );
            this.updataForm.score = data.data.score; // 分数
            //console.log(12321321321,this.updataForm.score)
            if (this.updataForm.score !== null && this.updataForm.score.length > 0) {
              this.isShowScore = true;
            }
            this.updataForm.passMarkScore = data.data.passMarkScore;
            this.updataForm.statusFirst = data.data.statusFirst;
            // this.scoreCache = data.data.score; // 缓存分数
            this.updataForm.registeId = data.data.registeId; // 报名ID
            this.updataForm.signId = data.data.signId; // 签到ID
            this.updataForm.isToday = data.data.isToday;
            this.updataForm.hasHandwork = data.data.hasHandwork;
            // this.updataForm.isToday = '1'; //测试
            // this.updataForm.hasHandwork = '1'; //测试
            this.updataForm.handworkAccountInfoDTO = data.data.handworkAccountInfoDTO;
            if (data.data.handworkAccountInfoDTO) {
              this.updataForm.isExistHandWork = data.data.handworkAccountInfoDTO.id
                ? true
                : false;
            }
            this.hisFileList = data.data.hisFileList;
            this.revisionDTOList = data.data.revisionDTOList;
            this.updataForm.trainingHistoryDTO = data.data.trainingHistoryDTO;
            this.$nextTick(() => {
              this.$refs["updataForm"].clearValidate(); // 移除校验
            });
            // 查询平账金额
            this.querySettledAmount();
            //console.log(111111111,data.data.handworkAccountInfoDTO)
            this.updataForm.balanceAccountTitle = data.data.handworkAccountInfoDTO
              ? data.data.handworkAccountInfoDTO.balanceAccountTitle
              : "";
            this.updataForm.balanceDes = data.data.handworkAccountInfoDTO
              ? data.data.handworkAccountInfoDTO.balanceDes
              : "";
            this.updataForm.amountType = data.data.handworkAccountInfoDTO
              ? data.data.handworkAccountInfoDTO.amountType
              : "";
            this.updataForm.singleAmount = data.data.handworkAccountInfoDTO
              ? data.data.handworkAccountInfoDTO.singleAmount
              : "";
            console.log(data.data.handworkAccountInfoDTO);
            if (data.data.handworkAccountInfoDTO.balanceAccountTitle === null) {
              this.lookPingZhang = true;
            }
          }
          // if (this.updataForm.score !== null && '' !== this.updataForm.score) {
          //   this.isShow = true
          // }
          // console.log(this.lookPingZhang)
          // if (!this.updataForm.balanceAccountTitle.length>0){
          //   this.lookPingZhang=true
          //   console.log(this.lookPingZhang)
          // }
        })
        .catch(function (error) {
          this.$message.error('服务器异常');
        });
    },
    // 关闭弹出框
    closeShowUpdataForm() {
      // refs在哪里
      this.$nextTick(() => {
        this.$refs.dataUpdataForm.resetFields();
      });
      this.$nextTick(() => {
        this.$refs["updataForm"].resetFields();
      });
      this.isShowUpdataForm = false;
    },
    // 关闭弹出框
    closeShowPenaltyCancelForm() {
      this.$refs["cancelPopUpInfo"].resetFields();
      this.$refs["immuneDataForm"].resetFields();
      this.isShowPenaltyCancelForm = false;
      this.form = {};
    },
    submitForm: function (formName) {
      if (
        this.updataForm.isChangeStatus ||
        this.updataForm.isChangeHandwork ||
        this.updataForm.isClearHandWork
      ) {
        console.log("updataSignMark ");
        console.log(this.isdisable);
        console.log(this.isShowScore);
        // console.log(this.updataForm.isChangeStatus,this.dataUpdataForm.afterStatus.length,this.updataForm.isChangeHandwork,this.updataForm.fileList.length);
        // if ((this.updataForm.isChangeStatus&&!this.updataForm.isChangeHandwork&&this.updataForm.fileList.length>=1)||
        //         (this.updataForm.isChangeStatus&&this.updataForm.fileList.length>=1&&(this.updataForm.isToday === '0' && this.updataForm.hasHandwork === '1'))){
        //   return this.$confirm('确定不修改状态直接保存, 是否继续?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     this.updateSub();
        //   }).catch(() => {
        //     this.$message({
        //       type: 'info',
        //       message: '已取消'
        //     });
        //   });
        // }
        // if (
        //   this.updataForm.isChangeStatus &&
        //   this.dataUpdataForm.afterStatus.length <= 0
        // ) {
        //   return this.$message({
        //     message: "签到记录或分数未发生改变，请修改后再保存",
        //     type: "warning",
        //     duration: 2000,
        //   });
        // }
        /*if (!this.isdisable && this.isShowScore) {
          this.$refs["updataForm"].validate((valid) => {
            if (!valid) {
              return false;
            }
            this.updateSub();
          });
        } else {
          this.$refs["updataForm"].validate((valid) => {
            if (!valid) {
              return false;
            }
            this.updateSub();
          });
        } */
        this.$refs["updataForm"].validate((valid) => {
            if (!valid) {
              return false;
            }
            this.updateSub();
        });
      } else {
        this.$message({
          message: "请选择修改内容",
          type: "warning",
        });
      }
    },

    // 提交免除扣款
    submitPenaltyImmuneForm() {
      console.log("ok");

      this.$refs["immuneDataForm"].validate((valid) => {
        if (valid) {
          // alert('submit!');
          let mesg = "本操作会将扣款金额清零，是否确认本操作？";
          this.$confirm(mesg, this.$t("prompt.title"), {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
          })
            .then(() => {
              this.$request
                .post(this.mixinViewModuleOptions.getCancelUpdateURL, {
                  offeringId: this.form.offeringId,
                  registeId: this.form.registeId,
                  userId: this.form.userId,
                  cancelUserName: this.cancelPopUpInfo.revokeUserName,
                  // immuneRemark: this.preText(this.immuneDataForm.immuneRemark),
                  immuneRemark: this.immuneDataForm.immuneRemark,
                  immuneReasonFlag: this.immuneDataForm.immuneReasonFlag,
                })
                .then((res, total, code, data) => {
                  this.isShowPenaltyCancelForm = false;
                  this.$refs["cancelPopUpInfo"].resetFields();
                  this.$refs["immuneDataForm"].resetFields();

                  this.getDataList();
                })
                .catch((e) => {
                  // console.log(e)
                });
            })
            .catch((err) => {
              console.log(err)
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //格式化数据
    preText(pretext) {
      return pretext
        .replace(/\r\n/g, "<br/>")
        .replace(/\n/g, "<br/>")
        .replace(/\s/g, "&nbsp;");
    },
    // 2021-08-27 添加..  整合验证提交
    updateSub() {
      var _this = this;

      if (
        _this.updataForm.isChangeStatus &&
        _this.isFlag === "1" &&
        !(_this.updataForm.score || _this.updataForm.score === "0") &&
        _this.isdisable === false
      ) {
        // if (this.updataForm.score) {
        _this.$message({
          message: "分数不能为空",
          type: "error",
          // duration: 3000
        });
        return;
      } else if (
        _this.updataForm.isChangeStatus &&
        _this.isFlag === "1" &&
        _this.isdisable === false &&
        (_this.updataForm.score < 0 ||
          _this.updataForm.score > 100 ||
          !/(^[0-9]+(\.[0-9]{1})?$)/.test(_this.updataForm.score))
      ) {
        _this.$message({
          message: "请输入正确的分数",
          type: "error",
          // duration: 3000
        });
        return;
      } else {
        if (this.updataForm.isClearHandWork) {
          this.$confirm("您已勾选清空平账单，请确定是否需要删除该平账信息？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              _this.loading = true;
              _this.updataForm.offeringSignDetailDTOList = _this.signData;
              // console.log(_this.updataForm.af)
              _this.$request
                .post(
                  _this.mixinViewModuleOptions.getSubmitSignMarkDataListURL,
                  _this.updataForm
                )
                .then((res, total, code, data) => {
                  if (data.code === 13000000) {
                    this.$message({
                      message: data.msg,
                      type: "error",
                      duration: 5000,
                      onClose: () => {
                        console.log('onClose')
                      },
                    });
                    _this.isShowUpdataForm = false;
                    _this.loading = false;
                    _this.getDataListMerge();
                  } else {
                    _this.$message({
                      message: _this.$t("prompt.success"),
                      type: "success",
                      duration: 500,
                    });
                    _this.isShowUpdataForm = false;
                    _this.loading = false;
                    _this.getDataListMerge();
                  }
                })
                .catch(function (error) {
                  _this.loading = false;
                  _this.$message.error('服务器异常');
                });
            })
            .catch(() => {
              // this.updataForm.isClearHandWork = false
            });
        } else {
          _this.loading = true;
          _this.updataForm.offeringSignDetailDTOList = _this.signData;
          _this.$request
            .post(
              _this.mixinViewModuleOptions.getSubmitSignMarkDataListURL,
              _this.updataForm
            )
            .then((res, total, code, data) => {
              if (data.code === 13000000) {
                this.$message({
                  message: data.msg,
                  type: "error",
                  duration: 5000,
                  onClose: () => {
                    console.log('onClose')
                  },
                });
                _this.isShowUpdataForm = false;
                _this.loading = false;
                _this.getDataListMerge();
              } else {
                _this.$message({
                  message: _this.$t("prompt.success"),
                  type: "success",
                  duration: 500,
                });
                _this.isShowUpdataForm = false;
                _this.loading = false;
                _this.getDataListMerge();
              }
            })
            .catch(function (error) {
              _this.loading = false;
              _this.$message.error('服务器异常');
            });
        }
      }
    },
    // 修改签到记录
    updataSign(row) {
      this.initDiallogFormData();
      this.$request
        .post(this.mixinViewModuleOptions.getUpdataSignMarkDataListURL, {
          offeringId: this.$route.query.offeringId,
          userId: row.userId,
          registeId: row.registeId,
        })
        .then((res, total, code, data) => {
          if (data.msg == "success") {
            this.signData = data.data.offeringSignDetailDTOList;
            // this.signStatusCache = data.data.offeringSignDetailDTOList[0].signStatus
            this.title = "修改签到记录";
            this.isFlag = "0";
            this.isShowScore = false;
            this.isValiDataScoreFlag = false;
            this.isShowUpdataForm = true;
            // this.$refs['updataForm'].resetFields();
            this.dataUpdataForm.firstNameCn = data.data.firstNameCn; // 姓名
            this.dataUpdataForm.lastNameCn = data.data.lastNameCn; // 姓名
            this.dataUpdataForm.userNameCn = data.data.userNameCn; //姓名
            this.dataUpdataForm.idcard = data.data.idcard; // 身份证
            this.dataUpdataForm.userCardNo = data.data.userCardNo; // 员工号
            if (data.data.fileList) {
              this.updataForm.fileList = data.data.fileList;
            }
            // this.updataForm.fileList = data.data.fileList;
            // console.info(this.updataForm.fileList);
            this.dataUpdataForm.orgName = data.data.orgName; // 经销商简称
            this.dataUpdataForm.positionNameCn = data.data.positionNameCn; // 主要职位
            this.dataUpdataForm.courseNameCn = data.data.courseNameCn;
            this.dataUpdataForm.siteName = data.data.siteName;
            this.revisionDTOList = data.data.revisionDTOList;
            this.dataUpdataForm.startdate = data.data.startdate;
            this.dataUpdataForm.enddate = data.data.enddate;
            this.dataUpdataForm.beforeStatus = data.data.beforeStatus;
            this.dataUpdataForm.afterStatus = this.registeapprovalstatus(
              0,
              0,
              data.data.afterStatus
            );
            this.originalSignRecord = JSON.parse(JSON.stringify(data.data));
            // this.afterStatusCache = this.registeapprovalstatus(
            //   0,
            //   0,
            //   data.data.afterStatus
            // );
            this.updataForm.score = data.data.score; // 分数
            this.updataForm.passMarkScore = data.data.passMarkScore;
            this.updataForm.statusFirst = data.data.statusFirst;
            // this.scoreCache = data.data.score; // 缓存分数
            this.updataForm.registeId = data.data.registeId; // 报名ID
            this.updataForm.signId = data.data.signId; // 签到ID
            this.updataForm.isToday = data.data.isToday;
            this.updataForm.hasHandwork = data.data.hasHandwork;
            // this.updataForm.isToday = '0'; //测试
            // this.updataForm.hasHandwork = '1';//测试
            this.updataForm.handworkAccountInfoDTO = data.data.handworkAccountInfoDTO;
            if (data.data.handworkAccountInfoDTO) {
              this.updataForm.isExistHandWork = data.data.handworkAccountInfoDTO.id
                ? true
                : false;
            }
            this.hisFileList = data.data.hisFileList;
            this.updataForm.trainingHistoryDTO = data.data.trainingHistoryDTO;
            this.$nextTick(() => {
              this.$refs["updataForm"].clearValidate(); // 移除校验
            });
            // 查询平账金额
            this.querySettledAmount();
          }
        })
        .catch(function (error) {
          this.$message.error('服务器异常');
        });
    },
    // 查看等候名单
    showWaitingList() {
      this.waitPage = 1;
      this.isShowWaitingList = true;
      this.waitingDataListLoading = true;
      this.queryWaitInfo();
    },
    // 等候名单查询
    queryWaitInfo() {
      this.$request
        .get(this.mixinViewModuleOptions.getWaitingDataListURL, {
          order: "",
          orderField: "",
          page: this.waitPage,
          limit: this.waitLimit,
          offeringId: this.dataForm.offeringId,
        })
        .then((res, total, code, data) => {
          this.waitingDataListLoading = false;
          let resultList = data.data.records;
          // this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? data.data.list : resultList
          this.waitingDataList = resultList;
          this.waitTotal = data.data.total;
        })
        .catch(() => {
          this.waitingDataListLoading = false;
        });
    },
    // 等候名单查询分页, 每页条数
    waitPageSizeChangeHandle(val) {
      this.waitPage = 1;
      this.waitLimit = val;
      this.queryWaitInfo();
    },
    // 等候名单查询分页, 当前页
    waitPageCurrentChangeHandle(val) {
      this.waitPage = val;
      this.queryWaitInfo();
    },
    // 替换用户
    replaceUser() {
      this.replaceUserVisible = true;
      this.$nextTick(() => {
        // 赋值初始化
        console.log(">>>>>>>>>>>>>>>用户id");
        this.$refs.replaceUser.dataofferinginfo.registeId = this.dataofferinginfo.registeId;
        this.$refs.replaceUser.dataofferinginfo.offeringId = this.dataofferinginfo.offeringId;
        this.$refs.replaceUser.dataofferinginfo.offeringNo = this.dataofferinginfo.offeringNo;
        this.$refs.replaceUser.dataofferinginfo.courseId = this.dataofferinginfo.courseId;
        this.$refs.replaceUser.dataofferinginfo.courseCode = this.dataofferinginfo.courseCode;
        this.$refs.replaceUser.dataofferinginfo.courseNameCn = this.dataofferinginfo.courseNameCn;
        this.$refs.replaceUser.dataofferinginfo.trainerName = this.dataofferinginfo.trainerName;
        this.$refs.replaceUser.dataofferinginfo.offeringName = this.dataofferinginfo.offeringName;
        this.$refs.replaceUser.dataofferinginfo.site = this.dataofferinginfo.site;
        this.$refs.replaceUser.dataofferinginfo.startdate = this.dataofferinginfo.startdate;
        this.$refs.replaceUser.dataofferinginfo.enddate = this.dataofferinginfo.enddate;
        this.$refs.replaceUser.init();
      });
    },
    // 调用撤销界面
    revoke(row) {
      /* eslint-disable */
      // debugger
      this.$router.push({
        name: "learning-course-registe-revokeuser",
        query: {
          registeId: row.registeId,
          userId: row.userId,
          offeringId: row.offeringId,
          showCheck: true,
          showCheckUser: true,
        },
      });
      this.$eventHub.$emit("view_undo_page_xpy", "");
    },
    // 调用撤销查看界面
    revokeView(row) {
      this.$router.push({
        name: "learning-course-registe-revokeuser",
        query: {
          registeId: row.registeId,
          userId: row.userId,
          offeringId: row.offeringId,
          isShow: this.isShow,
          showCheckUser: true,
        },
      });
      this.$eventHub.$emit("view_undo_page_xpy", "");
      // this.$eventHub.$emit('showViewUser', '')
    },

    // 导出
    exportHandle() {
      // download 参数 url, params, 报表名
      this.$request.download(
        "/learning/offeringregiste/exportUser",
        this.$t("assign.userExport"),
        {
          ...this.dataForm,
          page: this.page,
          limit: this.limit,
        }
      );
    },
    // 导出
    exportSignListToItm() {
      // download 参数 url, params, 报表名
      this.$request.downloadITM(
        "/learning/base/offeringinfo/exportSignListToItm",
        this.$t("assign.userExport"),
        {
          offeringId: this.dataForm.offeringId,
          offeringNo: this.dataForm.offeringNo,
        }
      );
    },
    registeapprovalstatus(row, column, cellValue) {
      // debugger
      if (cellValue === "10" || cellValue === 10) {
        return "待审核";
      } else if (cellValue === "20" || cellValue === 20) {
        return "已报名";
      } else if (cellValue === "30" || cellValue === 30) {
        return "已拒绝";
      } else if (cellValue === "40" || cellValue === 40) {
        return "已撤销";
      } else if (cellValue === "60" || cellValue === 60) {
        return "缺勤";
      } else if (cellValue === "70" || cellValue === 70) {
        return "已完成";
      } else if (cellValue === "80" || cellValue === 80) {
        return "未通过";
      } else {
        return "";
      }
    },
    initQuery() {
      /* eslint-disable */
      // debugger
      this.myHeader.token = this.getStorage(this.GLOBAL.TOKEN);
      this.dataofferinginfo.registeId = this.$route.query.registeId;
      this.dataofferinginfo.offeringId = this.$route.query.offeringId;
      this.dataForm.offeringId = this.$route.query.offeringId;
      this.allParam.offeringId = this.$route.query.offeringId;
      this.dataofferinginfo.offeringNo = this.$route.query.offeringNo;
      this.dataofferinginfo.courseId = this.$route.query.courseId;
      this.dataofferinginfo.courseCode = this.$route.query.courseCode;
      this.dataofferinginfo.courseNameCn = this.$route.query.courseNameCn;
      this.dataofferinginfo.trainerName = this.$route.query.trainerName;
      this.dataofferinginfo.offeringName = this.$route.query.offeringName;
      this.dataofferinginfo.site = this.$route.query.site;
      this.dataofferinginfo.startdate = this.$route.query.startdate;
      this.dataofferinginfo.enddate = this.$route.query.enddate;
      this.dataForm.coursePrice = this.$route.query.coursePrice;
      // this.mixinViewModuleOptions.getDataListURL =
      //   '/learning/offeringregiste/pageMembereList'
      this.mixinViewModuleOptions.getDataListIsPage = true;
      console.log(this.$route.query);
      this.dataForm.offeringNo = this.$route.query.offeringNo;
      (this.courseName = this.$route.query.courseName),
        (this.courseStartDate = this.$route.query.courseStartDate),
        (this.courseEndDate = this.$route.query.courseEndDate),
        (this.siteName = this.$route.query.siteName);
      this.getDataList();
    },
    // 查询平账金额
    querySettledAmount() {
      var _this = this;
      _this.settledAmountDetail = [];
      _this.settledAmount = 0;
      _this.$request
        .post("/learning/account/getBillingDetails", this.updataForm.trainingHistoryDTO)
        .then((res, total, code, data) => {
          if (data.msg == "success") {
            let sumNum = 0;
            _this.settledAmountDetail = data.data;
            data.data.forEach((item) => {
              if (item.billingPrice) {
                sumNum += item.billingPrice;
              }
            });
            _this.settledAmount = this.formatMoney(sumNum);
          }
        })
        .catch(function (error) {
          _this.$message.error('服务器异常');
        });
    },
    //文件下载
    downLoadFile(file) {
      this.$request.downloadBigFile(
        "/learning/account/picDownload",
        // this.$request.download('/sys/commAdminFileManagement/downloadFile',
        file.name,
        {
          url: file.url,
          name: file.name,
        },
        null,
        false
      );
    },
  },
  filters: {
    rounding(value) {
      if (value == null) {
        return null;
      } else {
        return value.toFixed(2);
      }
    },
    formatMoney(num) {
      if (!num && num !== 0 && num !== "0") {
        return "";
      }
      num = num.toString().replace(/\$|\,/g, "");
      if (isNaN(num)) {
        num = "0";
      }
      let sign = num == (num = Math.abs(num));
      num = Math.floor(num * 100 + 0.50000000001);
      let cents = num % 100;
      num = Math.floor(num / 100).toString();
      if (cents < 10) {
        cents = "0" + cents;
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num =
          num.substring(0, num.length - (4 * i + 3)) +
          "," +
          num.substring(num.length - (4 * i + 3));
      }
      return (sign ? "" : "-") + num + "." + cents;
    },
  },

  mounted() {
    /* eslint-disable */

    this.initQuery();
    this.$eventHub.$on("USER_QUERY_XPY66", (data) => {
      //debugger
      this.initQuery();
    });
  },

  beforeDestroy() {
    this.$eventHub.$off("USER_QUERY_XPY66");
  },
};
</script>
<style>
.aui-card-close .el-dialog__close {
  display: inline !important;
}
</style>
<style lang="scss">
.timeRange .el-form-item__label {
  width: 120px !important;
  margin-left: 30px;
}
.from-absolution {
  background-color: aliceblue;
}
/* 处理input type = number的上下箭头 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
.after-item .el-form-item__content {
  display: inline-block;
  margin-top: -4px;
}
.pz-item .el-form-item__label {
  float: none;
  color: #243243;
}
.pz-item .el-form-item__content {
  color: #243243;
}

// pop table
.new-pop {
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  padding: 16px !important;
  padding-top: 0 !important;
  .new-table {
    th {
      background-color: #fafbff !important;
      border-right: 0 !important;
      border-bottom: unset !important;

      .cell {
        color: rgba(37, 38, 40, 100);
        font-size: 14px;
        font-weight: bold;
      }
    }
    .el-table__body {
      td {
        color: rgba(37, 38, 40, 100);
        font-size: 14px;
        border-right: 0 !important;
      }
    }
  }
}
</style>
<style scoped lang="scss">
// @import "../../../../assets/scss/modules/trainingCharge.scss";
.el-dialog__body {
  padding: 5px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.el-input {
  width: 100%;
  /*max-width: 200px;*/
  /*min-width: 120px;*/
}
.export {
  height: 50px;
}
.search-item {
  width: 94% !important;
  min-width: 290px;
}
.el-form-item__content {
  width: 50% !important;
}
.top-size {
  float: right;
  padding-top: 10px;
  .el-button {
    width: 81px;
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 14px;
    color: #243243;
  }
  .el-button--primary {
    color: #fff;
  }
}

.gai {
  margin-top: 20px;
  margin-bottom: 20px;
   .el-checkbox__label {
    font-size: 16px;
    color: #243243;
    letter-spacing: 0;
    font-weight: 400;
    padding-left: 8px;
  }
}
.tuBiao {
}
.kuang {
  padding: 0 15px;
}

.bgc {
  background-color: #f3f7fc;
  border-top: 1px solid transparent;
  border-radius: 4px;
  // padding-left: 16px;
}
 .left-child-bottom {
  padding-bottom: 7px;
}
.bianju {
  padding-right: 10px;
  margin-left: -16px;
}
.pzbt .el-input__inner,
.bgc .el-input__inner {
  width: 90%;
}
.rightBgc {
  background-color: #f3f7fc;
  padding-left: 16px;
  padding-bottom: 16px;
  padding-right: 24px;
}
.after-item .el-form-item__content {
  margin-top: 0;
}
.top-form .el-form-item__content {
  /*单行文字溢出显示省略号*/
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.looKSignMarkBtn {
  color: rgba(28, 105, 212, 100);
  font-size: 12px;
  cursor: pointer;
  width: 100px !important;
  display: inline-block;
  margin-bottom: 3px;
}
.editSignMarkBtn {
  width: 120px !important;
  color: rgba(28, 105, 212, 100);
  font-size: 12px;
  display: inline-block;
  cursor: pointer;
}
.looKSignMarkdiv {
  margin-top: 5px;
  /*display: inline-block;*/
  /*position: absolute;*/
  /*left: 270px;*/
  /*top:18px*/
}
.editSignMarkdiv {
  display: inline-block;
  position: absolute;
  left: 270px;
  top: 18px;
}
.uploadDisable {
  cursor: not-allowed;
  background-color: #f2f4f5 !important;
  border: none;
  color: black !important;
}

/* //修改签到记录及分数 */
.xdjlfs-dialog {
  color: #243243;
  font-family: BMWGlobalProReg, sans-serif;

   .el-dialog__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px 24px;
    .el-dialog__header_cus {
      height: 22px;
      line-height: 22px;
      color: rgba(37, 38, 40, 100);
      font-size: 16px;
      position: relative;
      padding-left: 11px;
      &::before {
        content: "";
        width: 3px;
        height: 14px;
        border-radius: 1px;
        display: inline-block;
        background-color: rgba(28, 105, 212, 1);
        position: absolute;
        top: 4px;
        left: 0px;
      }
    }
  }
  .el-dialog__headerbtn .el-dialog__close {
    font-weight: 700;
    top: 14px !important;
  }
   .el-dialog__title {
    font-size: 16px;
    color: #243243;
    letter-spacing: 0;
    text-align: right;
    font-weight: 500;
  }
   .el-dialog__body {
    padding: 10px 24px 10px !important;
  }
  .top-form {
     .el-form-item__label {
      font-size: 14px;
      color: #a6adba;
      letter-spacing: 0;
      font-weight: 400;
    }
     .el-form-item__content {
      font-size: 14px;
      color: #243243;
      letter-spacing: 0;
    }
  }
  .center-line {
    margin-top: 2px;
    height: 1px;
    border: 1px dotted rgba(0, 0, 0, 0.1);
  }
  .temp-top {
    padding: 16px 0px;
    border-bottom: 1px solid rgba(153, 154, 156, 0.5);
    // title icon
    .tuBiao {
      display: inline-block;
      margin-right: 8px;
      margin-left: 16px;
      width: 3px;
      height: 12px;
      border-radius: 1px;
      background-color: rgba(5, 122, 255, 1);
      vertical-align: middle;
    }
    .bgc-title {
      color: rgba(37, 38, 40, 100);
      font-size: 14px;
      vertical-align: middle;
      line-height: 20px;
    }
  }
  .score-lable {
    //  .el-form-item__label {
    // 	float: none;
    // }
    //  .el-form-item__content {
    // 	width: calc(100% - 12px);
    // 	margin-top: 10px;
    // }
  }
  .pass-score {
     .el-form-item__label,
     .el-form-item__content {
      color: #3c4e64;
      font-size: 12px;
    }
  }
  .before-change {
    font-size: 14px;
     .el-form-item__label {
      color: #a6adba;
    }
     .el-form-item__content {
      color: #243243;
      // border-right: 1px solid rgba(0, 0, 0, 0.1);
      // height: 12px;
    }
  }
  .line-co {
    height: 23px;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .mi-line {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    height: 13px;
    width: 1px;
  }
  .after-change {
    margin-left: 5px;
     .el-form-item__label {
      color: #a6adba;
    }
     .el-form-item__content {
      color: #f56f6f;
    }
  }
  .settled-amount {
    .amount-label {
      color: rgba(37, 38, 40, 100);
      font-size: 14px;
    }
    .amount-money {
      color: rgba(28, 105, 212, 100);
      font-size: 18px;
      cursor: pointer;
    }
    // margin-top: 11px;
    // .label {
    // 	color: #243243;
    // 	font-size: 14px;
    // }
  }
  .dis-div {
    opacity: 0.5;
  }
   .el-textarea {
    .el-input__count {
      color: #808ea9;
      opacity: 0.5;
    }
  }
}

// 改版ui
.checkbox-title {
  margin: 10px 0px 10px 0px;
   .is-checked {
    .el-checkbox__label {
      color: rgba(37, 38, 40, 100) !important;
    }
  }
}
.status-container {
  padding: 16px;
  .tag-wrap {
     .el-tag {
      width: 85px;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      text-align: center;
      margin-right: 10px;
      background: white;
      margin-bottom: 10px;
      cursor: pointer;
      &.el-tag--success {
        color: rgba(11, 203, 144, 1) !important;
        border-color: rgba(11, 203, 144, 1) !important;
        &:hover {
          background: rgba(11, 203, 144, 0.05) !important;
        }
      }
      &.el-tag--danger {
        color: rgba(255, 65, 65, 1) !important;
        border-color: rgba(255, 65, 65, 1) !important;
        &:hover {
          background: rgba(255, 65, 65, 0.05) !important;
        }
      }
    }
  }
   .el-form-item {
    width: 100% !important;
    margin-bottom: 0px !important;
    // height:20px;
    // line-height: 20px;
    &.before-change {
      display: flex;
      position: relative;
      align-items: center;
      width: auto !important;
      &::after {
        position: absolute;
        right: 0;
        top: 0;
        width: 1px;
        height: 10px;
        background-color: rgba(153, 154, 156, 1);
      }
    }
  }
  // 分数展示
  .score-container {
    display: flex;
    margin-bottom: 16px;
    // align-items:center;
    .score-wrap {
      display: inline-block;

      margin-top: 7px;
       .el-form-item {
        display: flex;
        align-items: center;
        // margin-left:-12px;
        height: 32px;
        line-height: 32px;
      }
       .el-form-item__content {
        width: 291px !important;
      }
       .el-input__inner {
        width: 100% !important;
      }
      .score-tip {
        margin-left: 54px;
        height: 17px;
        line-height: 17px;
        color: rgba(109, 110, 112, 100);
        font-size: 12px;
        text-align: left;
        margin-top: 15px;
      }
    }
    .score-pop-list {
      margin-top: 10px;
    }
  }

  // 状态展示
  .status-show-wrap {
    font-size: 0;
    > span {
      height: 20px;
      line-height: 20px;
      color: rgba(153, 154, 156, 100);
      font-size: 14px;
      text-align: left;
      display: inline-block;
      vertical-align: middle;
    }
    > i {
      margin: 0 16px;
      display: inline-block;
      vertical-align: middle;
      width: 1px;
      height: 10px;
      background-color: rgba(153, 154, 156, 1);
    }
    > span:last-child {
      > span {
      }
    }
  }
}
// 顶部table 样式
.top-form {
  .el-col-6 {
    padding-right: 20px;
  }
  .el-form-item {
    width: 100% !important;
    margin-bottom: 18px !important;
  }
  .el-form-item__label {
    width: 72px !important;
    text-align: left;
  }
}

// 凭帐
 .pingzhang {
  .el-form-item {
    display: flex;
    margin-bottom: 0px !important;
    // align-items: center;
    .el-button {
      width: 180px;
      height: 32px;
      border-radius: 4px;
      background-color: rgba(28, 105, 212, 1);
    }
    .el-upload-list__item {
      width: 317px;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      margin-top: 10px;
      color: rgba(37, 38, 40, 100);
      border: 1px solid rgba(11, 203, 144, 1);
      &:first-child {
        margin-top: 16px;
      }
      &:hover {
        background-color: rgba(0, 206, 98, 0.05);
        .el-icon-close {
          margin-top: 2px;
          &::before {
            font-size: 10px;
            transform: scale(0.8);
            color: rgba(11, 203, 144, 1);
          }
        }
        .el-icon-upload-success {
          display: block !important;
          content: "\E720";
          font-size: 16px;
          color: rgba(11, 203, 144, 1);
        }
      }
      .el-upload-list__item-name {
        padding-left: 32px !important;
      }
      > a:hover {
        color: rgba(37, 38, 40, 100) !important;
        text-decoration: none !important;
        .el-icon-upload-success {
          display: block !important;
          content: "\E720";
          font-size: 16px;
          color: rgba(11, 203, 144, 1);
        }
      }
      .el-icon-document {
        display: none;
      }
      .el-upload-list__item-status-label {
        left: 10px !important;
        right: 0px !important;
        .el-icon-upload-success {
          &::before {
            font-size: 16px;
            color: rgba(11, 203, 144, 1);
          }
        }
      }
    }
  }
  .el-form-item__label {
    font-size: 14px;
    line-height: 32px !important;
    width: 82px;
    flex-shrink: 0;
    padding-right: 0px !important;
    text-align: left !important;
  }
}

 .pz-item {
  display: flex;
  .el-form-item__content {
    width: 100% !important;
  }
  .el-form-item__label {
    flex-shrink: 0;
  }
  &.pz-item-title,
  &.pz-item-area {
    width: 100% !important;
    margin-bottom: 0px !important;
    .el-form-item__label {
      line-height: 32px !important;
      width: 82px !important;
      padding-right: 0;
      text-align: right;
    }
  }
  &.pz-item-records {
    width: 100%;
    margin-bottom: 16px !important;
    .el-form-item__label {
      line-height: 32px !important;
      width: 180px !important;
      padding-right: 0;
      text-align: right;
    }
  }
}

.xdjlfs-dialog {
  .is-error {
     .el-input__inner,
     .el-textarea__inner {
      border-color: #f56c6c !important;
    }
  }
   .el-input__inner,
   .el-textarea__inner {
    border-radius: 2px !important;
    background-color: rgba(255, 255, 255, 1) !important;
    border-color: white !important;
    &:focus {
      border-color: rgba(28, 105, 212, 1) !important;
    }

    &:disabled {
      background-color: rgba(242, 244, 245, 1) !important;
      border: 1px solid rgba(223, 224, 226, 1) !important;
    }
  }
   .el-textarea__inner {
    min-height: 68px !important;
    resize: none;
  }

  // checkbox
   .el-checkbox {
    &.is-checked {
      .el-checkbox__inner {
        background-color: #1c69d3;
        border-color: #1c69d3;
        &::after {
          height: 8px;
          left: 6px;
          top: 2px;
        }
      }
    }
    .el-checkbox__inner {
      width: 18px;
      height: 18px;
      border-radius: 4px;
      border: 1px solid rgba(190, 191, 193, 1);
    }
  }
}
// 清空平账单样式
.disabled-container {
   .bgc-title,
   .el-form-item__label {
    color: rgba(37, 38, 40, 0.3) !important;
  }
   .el-input__inner,
   .el-textarea__inner {
    &:disabled {
      background-color: rgba(255, 255, 255, 1) !important;
      border: 1px solid rgba(255, 255, 255, 1) !important;
    }
  }
}
 .el-button {
  border-radius: 4px !important;
  padding: 8px 24px !important;
  font-weight: 100 !important;
}
</style>
